import React, { useEffect, useRef, useState } from "react";

import { CiFilter } from "react-icons/ci";
import { AiOutlineCalendar } from "react-icons/ai";
import { Row, Col, Dropdown } from "react-bootstrap";
import GreyTable from "../../../components/Tables/GreyTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { DndContext, closestCenter } from "@dnd-kit/core";

import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { restrictToParentElement } from "@dnd-kit/modifiers";
import { format } from "date-fns";
import { enUS, ru } from "date-fns/locale";

import { QualityListwise } from "../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import DroupdownFilterBox from "../../../components/FilterBox/DroupdownFilterBox";
import Calendar from "react-calendar";
import {
  BookWiseBookWiseDtl,
  BookWiseBookWiseSumm,
  BookWiseDateWiseDtl,
  BookWiseDateWiseSumm,
  BookWiseGroupWiseDtl,
  BookWiseGroupWiseSumm,
  BookWiseItemWiseDtl,
  BookWiseItemWiseSumm,
  BookWiseMonthWiseDtl,
  BookWiseMonthWiseSumm,
  BookWisePartyWiseDtl,
  BookWisePartyWiseSumm,
  DateWiseBookWiseDtl,
  DateWiseBookWiseSumm,
  DateWiseDateWiseDtl,
  DateWiseDateWiseSumm,
  DateWiseGroupWiseDtl,
  DateWiseGroupWiseSumm,
  DateWiseItemWiseDtl,
  DateWiseItemWiseSumm,
  DateWisePartyWiseDtl,
  DateWisePartyWiseSumm,
  GroupWiseBookWiseDtl,
  GroupWiseBookWiseSumm,
  GroupWiseDateWiseDtl,
  GroupWiseDateWiseSumm,
  GroupWiseGroupWiseDtl,
  GroupWiseGroupWiseSumm,
  GroupWiseItemWiseDtl,
  GroupWiseItemWiseSumm,
  GroupWiseMonthWiseDtl,
  GroupWiseMonthWiseSumm,
  GroupWisePartyWiseDtl,
  GroupWisePartyWiseSumm,
  ItemWiseBookWiseDtl,
  ItemWiseBookWiseSumm,
  ItemWiseDateWiseDtl,
  ItemWiseDateWiseSumm,
  ItemWiseGroupWiseDtl,
  ItemWiseGroupWiseSumm,
  ItemWiseItemWiseDtl,
  ItemWiseItemWiseSumm,
  ItemWiseMonthWiseDtl,
  ItemWiseMonthWiseSumm,
  ItemWisePartyWiseDtl,
  ItemWisePartyWiseSumm,
  MonthWiseBookWiseDtl,
  MonthWiseBookWiseSumm,
  MonthWiseGroupWiseDtl,
  MonthWiseGroupWiseSumm,
  MonthWiseItemWiseDtl,
  MonthWiseItemWiseSumm,
  MonthWiseMonthWiseDtl,
  MonthWiseMonthWiseSumm,
  MonthWisePartyWiseDtl,
  MonthWisePartyWiseSumm,
  PartyWiseBookWiseDtl,
  PartyWiseBookWiseSumm,
  PartyWiseDateWiseDtl,
  PartyWiseDateWiseSumm,
  PartyWiseGroupWiseDtl,
  PartyWiseGroupWiseSumm,
  PartyWiseItemWiseDtl,
  PartyWiseItemWiseSumm,
  PartyWiseMonthWiseDtl,
  PartyWiseMonthWiseSumm,
  PartyWisePartyWiseDtl,
  PartyWisePartyWiseSumm,
  resetBookWiseBookWiseDetail,
  resetBookWiseBookWiseSummary,
  resetBookWiseDateWiseDetail,
  resetBookWiseDateWiseSummary,
  resetBookWiseGroupWiseDetail,
  resetBookWiseGroupWiseSummary,
  resetBookWiseItemWiseDetail,
  resetBookWiseItemWiseSummary,
  resetBookWiseMonthWiseDetail,
  resetBookWiseMonthWiseSummary,
  resetBookWisePartyWiseDetail,
  resetBookWisePartyWiseSummary,
  resetDateWiseBookWiseDetail,
  resetDateWiseBookWiseSummary,
  resetDateWiseDateWiseDetail,
  resetDateWiseDateWiseSummary,
  resetDateWiseGroupWiseDetail,
  resetDateWiseGroupWiseSummary,
  resetDateWiseItemWiseDetail,
  resetDateWiseItemWiseSummary,
  resetDateWisePartyWiseDetail,
  resetDateWisePartyWiseSummary,
  resetGroupWiseBookWiseDetail,
  resetGroupWiseBookWiseSummary,
  resetGroupWiseDateWiseDetail,
  resetGroupWiseDateWiseSummary,
  resetGroupWiseGroupWiseDetail,
  resetGroupWiseGroupWiseSummary,
  resetGroupWiseItemWiseDetail,
  resetGroupWiseItemWiseSummary,
  resetGroupWiseMonthWiseDetail,
  resetGroupWiseMonthWiseSummary,
  resetGroupWisePartyWiseDetail,
  resetGroupWisePartyWiseSummary,
  resetItemWiseBookWiseDetail,
  resetItemWiseBookWiseSummary,
  resetItemWiseDateWiseDetail,
  resetItemWiseDateWiseSummary,
  resetItemWiseGroupWiseDetail,
  resetItemWiseGroupWiseSummary,
  resetItemWiseItemWiseDetail,
  resetItemWiseItemWiseSummary,
  resetItemWiseMonthWiseDetail,
  resetItemWiseMonthWiseSummary,
  resetItemWisePartyWiseDetail,
  resetItemWisePartyWiseSummary,
  resetMonthWiseBookWiseDetail,
  resetMonthWiseBookWiseSummary,
  resetMonthWiseGroupWiseDetail,
  resetMonthWiseGroupWiseSummary,
  resetMonthWiseItemWiseDetail,
  resetMonthWiseItemWiseSummary,
  resetMonthWiseMonthWiseDetail,
  resetMonthWiseMonthWiseSummary,
  resetMonthWisePartyWiseDetail,
  resetMonthWisePartyWiseSummary,
  resetPartyWiseBookWiseDetail,
  resetPartyWiseBookWiseSummary,
  resetPartyWiseDateWiseDetail,
  resetPartyWiseDateWiseSummary,
  resetPartyWiseGroupWiseDetail,
  resetPartyWiseGroupWiseSummary,
  resetPartyWiseItemWiseDetail,
  resetPartyWiseItemWiseSummary,
  resetPartyWiseMonthWiseDetail,
  resetPartyWiseMonthWiseSummary,
  resetPartyWisePartyWiseDetail,
  resetPartyWisePartyWiseSummary,
} from "../../../Redux/Slice/Grey/GroupInwardReport/GroupInwardReportSlice";
import GreyParentChild from "../../../components/Tables/GreyParentChild";
import { useMemo } from "react";
import { Loader } from "../../../components/Loader/Loader";
import { alignPropType } from "react-bootstrap/esm/types";
import { useTheme } from "../../../Themecontext/Themecontext";
import CommonCalendarStyle from "../../../components/Calendar/GreyCalenderCSS";

const initialData = [
  { id: "1", label: "DateWise", checked: false },
  { id: "2", label: "Partywise", checked: false },
  { id: "3", label: "Itemwise", checked: false },
  { id: "4", label: "Groupwise", checked: false },
  { id: "5", label: "Bookwise", checked: false },
  { id: "6", label: "Monthwise", checked: false },
  // { id: "7", label: "Datewise", checked: false },
];

function SortableItem({ item, toggleCheck, items, isdark, iscolour, iscolourDark }) {
  const [isHover, setIsHover] = useState(false);
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const isChecked = item.checked;
  const isDisabled = !isChecked && items.filter((i) => i.checked).length >= 2;

  const itemBackground = isdark === "light"
    ? (isChecked
      ? (iscolour?.Colour12 || "#e9ecef")
      : (isHover ? (iscolour?.Colour4 || "#f1f3f5") : (iscolour?.Colour5 || "#ffffff")))
    : (isChecked
      ? (iscolourDark?.Colour11 || "#2d3748")
      : (isHover ? (iscolourDark?.Colour12 || "#2a2f3b") : (iscolourDark?.Colour7 || "#1a202c")));

  const itemTextColor = isdark === "light"
    ? (iscolour?.Colour2 || "#212529")
    : (iscolourDark?.Colour2 || "#ffffff");

  const itemBorder = isdark === "light"
    ? `1px solid ${isChecked ? (iscolour?.Colour1 || "#1b4332") : (isHover ? (iscolour?.Colour1 || "#cbd5e1") : (iscolour?.Colour4 || "#e2e8f0"))}`
    : `1px solid ${isChecked ? (iscolourDark?.Colour11 || "#4a5568") : (isHover ? (iscolourDark?.Colour1 || "#4a5568") : (iscolourDark?.Colour3 || "#2d3748"))}`;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: "flex",
    alignItems: "center",
    padding: "10px 14px",
    marginBottom: "8px",
    borderRadius: "12px",
    cursor: "default",
    border: itemBorder,
    background: itemBackground,
    color: itemTextColor,
    opacity: isDisabled ? 0.5 : 1,
    boxShadow: isHover && !isDisabled ? "0 4px 12px rgba(0,0,0,0.08)" : "none",
    transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <style>
        {`
          .theme-sortable-checkbox-${item.id} .form-check-input {
            background-color: ${isdark === "light" ? "#ffffff" : (iscolourDark?.Colour6 || "#1a202c")} !important;
            border-color: ${isdark === "light" ? (iscolour?.Colour4 || "#cbd5e1") : (iscolourDark?.Colour3 || "#4a5568")} !important;
            cursor: ${isDisabled ? "not-allowed" : "pointer"} !important;
          }
          .theme-sortable-checkbox-${item.id} .form-check-input:checked {
            background-color: ${isdark === "light" ? (iscolour?.Colour1 || "#1b4332") : (iscolourDark?.Colour1 || "rgb(82, 183, 136)")} !important;
            border-color: ${isdark === "light" ? (iscolour?.Colour1 || "#1b4332") : (iscolourDark?.Colour1 || "rgb(82, 183, 136)")} !important;
          }
          .theme-sortable-checkbox-${item.id} .form-check-input:focus {
            box-shadow: 0 0 0 0.2rem ${isdark === "light" ? `${iscolour?.Colour1 || "#1b4332"}25` : `${iscolourDark?.Colour11 || "#2d3748"}25`} !important;
          }
        `}
      </style>

      {/* 🔥 Drag only from icon */}
      <span
        {...attributes}
        {...listeners}
        style={{
          marginRight: "12px",
          cursor: isDisabled ? "not-allowed" : "grab",
          color: isdark === "light"
            ? (isChecked ? (iscolour?.Colour2 || "#6c757d") : "#999999")
            : (isChecked ? (iscolourDark?.Colour2 || "#ffffff") : "rgba(255, 255, 255, 0.4)"),
          fontSize: "18px",
          display: "flex",
          alignItems: "center",
          opacity: 0.8,
        }}
      >
        ⠿
      </span>

      {/* ✅ Checkbox properly clickable */}
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <Form.Check
          className={`theme-sortable-checkbox-${item.id}`}
          type="checkbox"
          checked={item.checked}
          disabled={isDisabled}
          onChange={() => toggleCheck(item.id)}
          id={`checkbox-${item.id}`}
          label={
            <span
              style={{
                color: itemTextColor,
                fontWeight: isChecked ? "600" : "500",
                fontSize: "14px",
                cursor: isDisabled ? "not-allowed" : "pointer",
                userSelect: "none",
                marginLeft: "4px",
                opacity: isChecked ? 1 : 0.7,
              }}
            >
              {item.label}
            </span>
          }
          style={{
            cursor: isDisabled ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
          }}
        />
      </div>
    </div>
  );
}
export const GreyInwardReport = () => {
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");
  const dispatch = useDispatch();

  const [reportType, setReportType] = useState("detail");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedPath, setSelectedPath] = useState([]);
  const [activeInfoButton, setActiveInfoButton] = useState("Inward");
  const [hoveredButton, setHoveredButton] = useState("");

  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState(null);

  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState(null);

  const [selectedQuality, setSelectedQuality] = useState("");
  const [selectedQualityId, setSelectedQualityId] = useState(null);

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { mainFilterData } = useSelector((state) => state.ClientLogin);
  const { QualityListdata } = useSelector((state) => state.GreyDashboardSlice);
  const {
    DateWiseDateWiseDtlData,
    DateWisePartyWiseDtlData,
    DateWiseItemWiseDtlData,
    DateWiseGroupWiseDtlData,
    DateWiseBookWiseDtlData,

    PartyWisePartyWiseDtlData,
    PartyWiseDateWiseDtlData,
    PartyWiseItemWiseDtlData,
    PartyWiseGroupWiseDtlData,
    PartyWiseBookWiseDtlData,
    PartyWiseMonthWiseDtlData,

    ItemWiseItemWiseDtlData,
    ItemWiseDateWiseDtlData,
    ItemWisePartyWiseDtlData,
    ItemWiseGroupWiseDtlData,
    ItemWiseBookWiseDtlData,
    ItemWiseMonthWiseDtlData,

    GroupWiseGroupWiseDtlData,
    GroupWiseDateWiseDtlData,
    GroupWisePartyWiseDtlData,
    GroupWiseItemWiseDtlData,
    GroupWiseBookWiseDtlData,
    GroupWiseMonthWiseDtlData,

    BookWiseBookWiseDtlData,
    BookWiseDateWiseDtlData,
    BookWisePartyWiseDtlData,
    BookWiseItemWiseDtlData,
    BookWiseGroupWiseDtlData,
    BookWiseMonthWiseDtlData,

    MonthWiseMonthWiseDtlData,
    MonthWisePartyWiseDtlData,
    MonthWiseItemWiseDtlData,
    MonthWiseGroupWiseDtlData,
    MonthWiseBookWiseDtlData,

    DateWiseDateWiseSummData,
    DateWisePartyWiseSummData,
    DateWiseItemWiseSummData,
    DateWiseGroupWiseSummData,
    DateWiseBookWiseSummData,

    PartyWisePartyWiseSummData,
    PartyWiseDateWiseSummData,
    PartyWiseItemWiseSummData,
    PartyWiseGroupWiseSummData,
    PartyWiseBookWiseSummData,
    PartyWiseMonthWiseSummData,

    ItemWiseItemWiseSummData,
    ItemWiseDateWiseSummData,
    ItemWisePartyWiseSummData,
    ItemWiseGroupWiseSummData,
    ItemWiseBookWiseSummData,
    ItemWiseMonthWiseSummData,

    MonthWiseMonthWiseSummData,
    MonthWisePartyWiseSummData,
    MonthWiseItemWiseSummData,
    MonthWiseGroupWiseSummData,
    MonthWiseBookWiseSummData,

    GroupWiseGroupWiseSummData,
    GroupWiseDateWiseSummData,
    GroupWisePartyWiseSummData,
    GroupWiseItemWiseSummData,
    GroupWiseBookWiseSummData,
    GroupWiseMonthWiseSummData,

    BookWiseBookWiseSummData,
    BookWiseDateWiseSummData,
    BookWisePartyWiseSummData,
    BookWiseItemWiseSummData,
    BookWiseGroupWiseSummData,
    BookWiseMonthWiseSummData,
  } = useSelector((state) => state.GroupInwardReportSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  // function parseRangeToDates(rangeString) {
  //   if (!rangeString) return { startDate: null, endDate: null };

  //   const [startStr, endStr] = rangeString.split(" - ");

  //   const parseDDMMYYYY = (s) => {
  //     const [day, month, year] = s.split("/").map(Number);
  //     return new Date(year, month - 1, day);
  //   };

  //   return {
  //     startDate: parseDDMMYYYY(startStr),
  //     endDate: parseDDMMYYYY(endStr),
  //   };
  // }

  function extractDatesFromFirm(matchedYear) {
    if (!matchedYear || !matchedYear.includes("-")) {
      return { startDate: null, endDate: null };
    }

    const [start] = matchedYear.split(" - ");
    const [dd, mm, yyyy] = start.split("/");

    return {
      startDate: new Date(yyyy, 3, 1), // April = 3 (0-based)
      endDate: new Date(yyyy, 3, 30),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!mainFilterData || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    mainFilterData?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = extractDatesFromFirm(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [mainFilterData, FinancialYear]);

  // ✅ sahi
  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(QualityListwise({}));
  }, [dispatch]);

  const infoButtons = ["Opening", "Inward", "Delivery", "Balance"];

  // const columns = [
  //   { Header: "Date", accessor: "date" },
  //   { Header: "Party Name", accessor: "partyName" },
  //   { Header: "Item Name", accessor: "itemName" },
  //   { Header: "Opening", accessor: "opening" },
  //   { Header: "Inward", accessor: "inwrd" },
  //   { Header: "Delivery", accessor: "delivery" },
  //   { Header: "Balance", accessor: "balance" },
  // ];

  // const data = [
  //   {
  //     date: "01/03/2026",
  //     partyName: "ABC Textiles",
  //     itemName: "Cotton Grey",
  //     opening: 120,
  //     inwrd: 40,
  //     delivery: 30,
  //     balance: 130,
  //   },
  //   {
  //     date: "02/03/2026",
  //     partyName: "Mahalaxmi Fabrics",
  //     itemName: "Polyester Grey",
  //     opening: 90,
  //     inwrd: 25,
  //     delivery: 20,
  //     balance: 95,
  //   },
  //   {
  //     date: "03/03/2026",
  //     partyName: "Shree Krishna Mills",
  //     itemName: "Viscose Grey",
  //     opening: 150,
  //     inwrd: 35,
  //     delivery: 50,
  //     balance: 135,
  //   },
  // ];

  const resetSectionState = () => {
    setSelectedSection("");
    setSelectedPath([]);
    setActiveInfoButton("Inward");
  };

  const currentTitle =
    reportType === "detail" ? "DETAIL GRAY INWARD" : "SUMMARY";

  const showFinalReport = selectedPath.length >= 3;

  const commonFieldStyle = {
    width: "100%",
    minWidth: "0",
    maxWidth: "100%",
    minHeight: "46px",
    padding: "0.75rem 1rem",
    borderRadius: "8px",
    boxSizing: "border-box",
    fontSize: "0.875rem",
    fontWeight: "600",
    outline: "none",
  };

  const commonButtonStyle = {
    width: "100%",
    minWidth: "0",
    maxWidth: "100%",
    minHeight: "46px",
    padding: "12px 14px",
    borderRadius: "10px",
    boxSizing: "border-box",
    fontSize: "0.875rem",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: "1.2",
  };

  const [items, setItems] = useState(initialData);

  // const [parentKey, setParentKey] = useState("");
  // const [childKey, setChildKey] = useState("");

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = items.findIndex((i) => i.id === active.id);
      const newIndex = items.findIndex((i) => i.id === over.id);

      setItems(arrayMove(items, oldIndex, newIndex));
    }
  };

  const toggleCheck = (id) => {
    setItems((prev) => {
      const selectedCount = prev.filter((i) => i.checked).length;

      return prev.map((item) => {
        if (item.id === id) {
          if (item.checked) {
            return { ...item, checked: false };
          }

          if (selectedCount < 2) {
            return { ...item, checked: true };
          }

          return item;
        }
        return item;
      });
    });
  };

  const getSelectedGroups = () => {
    return items.filter((i) => i.checked).map((i) => i.label);
  };

  // 👇 ab safe hai
  const selected = getSelectedGroups();

  console.log(selected);

  // const selectAll = () => {
  //   setItems(items.map((i) => ({ ...i, checked: true })));
  // };

  const clearAll = () => {
    setItems(items.map((i) => ({ ...i, checked: false })));
  };

  // const [tableData, setTableData] = useState([]);

  // // const [rows, setrows] = useState([]);
  // // const [columns, setcolumns] = useState([]);

  // const [Balrows, setBalrows] = useState([]);
  // const [Balcolumns, setBalcolumns] = useState([]);

  const [GroupKey, setGroupKey] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  console.log(GroupKey);




  const handleApiCall = () => {
    // DATE WISE
    dispatch(resetDateWiseDateWiseDetail());
    dispatch(resetDateWisePartyWiseDetail());
    dispatch(resetDateWiseItemWiseDetail());
    dispatch(resetDateWiseGroupWiseDetail());
    dispatch(resetDateWiseBookWiseDetail());

    dispatch(resetDateWiseDateWiseSummary());
    dispatch(resetDateWisePartyWiseSummary());
    dispatch(resetDateWiseItemWiseSummary());
    dispatch(resetDateWiseGroupWiseSummary());
    dispatch(resetDateWiseBookWiseSummary());

    // BOOK WISE
    dispatch(resetBookWiseBookWiseDetail());
    dispatch(resetBookWiseDateWiseDetail());
    dispatch(resetBookWisePartyWiseDetail());
    dispatch(resetBookWiseItemWiseDetail());
    dispatch(resetBookWiseGroupWiseDetail());
    dispatch(resetBookWiseMonthWiseDetail());

    dispatch(resetBookWiseBookWiseSummary());
    dispatch(resetBookWiseDateWiseSummary());
    dispatch(resetBookWisePartyWiseSummary());
    dispatch(resetBookWiseItemWiseSummary());
    dispatch(resetBookWiseGroupWiseSummary());
    dispatch(resetBookWiseMonthWiseSummary());

    // PARTY WISE
    dispatch(resetPartyWisePartyWiseDetail());
    dispatch(resetPartyWiseDateWiseDetail());
    dispatch(resetPartyWiseItemWiseDetail());
    dispatch(resetPartyWiseGroupWiseDetail());
    dispatch(resetPartyWiseBookWiseDetail());
    dispatch(resetPartyWiseMonthWiseDetail());

    dispatch(resetPartyWisePartyWiseSummary());
    dispatch(resetPartyWiseDateWiseSummary());
    dispatch(resetPartyWiseItemWiseSummary());
    dispatch(resetPartyWiseGroupWiseSummary());
    dispatch(resetPartyWiseBookWiseSummary());
    dispatch(resetPartyWiseMonthWiseSummary());

    // ITEM WISE
    dispatch(resetItemWiseItemWiseDetail());
    dispatch(resetItemWiseDateWiseDetail());
    dispatch(resetItemWisePartyWiseDetail());
    dispatch(resetItemWiseGroupWiseDetail());
    dispatch(resetItemWiseBookWiseDetail());
    dispatch(resetItemWiseMonthWiseDetail());

    dispatch(resetItemWiseItemWiseSummary());
    dispatch(resetItemWiseDateWiseSummary());
    dispatch(resetItemWisePartyWiseSummary());
    dispatch(resetItemWiseGroupWiseSummary());
    dispatch(resetItemWiseBookWiseSummary());
    dispatch(resetItemWiseMonthWiseSummary());

    // GROUP WISE
    dispatch(resetGroupWiseGroupWiseDetail());
    dispatch(resetGroupWiseDateWiseDetail());
    dispatch(resetGroupWisePartyWiseDetail());
    dispatch(resetGroupWiseItemWiseDetail());
    dispatch(resetGroupWiseBookWiseDetail());
    dispatch(resetGroupWiseMonthWiseDetail());

    dispatch(resetGroupWiseGroupWiseSummary());
    dispatch(resetGroupWiseDateWiseSummary());
    dispatch(resetGroupWisePartyWiseSummary());
    dispatch(resetGroupWiseItemWiseSummary());
    dispatch(resetGroupWiseBookWiseSummary());
    dispatch(resetGroupWiseMonthWiseSummary());

    // MONTH WISE
    dispatch(resetMonthWiseMonthWiseDetail());
    dispatch(resetMonthWisePartyWiseDetail());
    dispatch(resetMonthWiseItemWiseDetail());
    dispatch(resetMonthWiseGroupWiseDetail());
    dispatch(resetMonthWiseBookWiseDetail());

    dispatch(resetMonthWiseMonthWiseSummary());
    dispatch(resetMonthWisePartyWiseSummary());
    dispatch(resetMonthWiseItemWiseSummary());
    dispatch(resetMonthWiseGroupWiseSummary());
    dispatch(resetMonthWiseBookWiseSummary());

    if (selected.length === 0) {
      setIsSubmitted(false);
      return;
    }

    setIsSubmitted(true);

    const groupKey = selected.join("-");
    setGroupKey(groupKey);

    let apiFunction = null;

    if (reportType === "detail") {
      apiFunction = detailApiMap[groupKey];

    } else if (reportType === "summary") {
      apiFunction = summaryApiMap[groupKey];
    }

    if (!apiFunction) {
      console.log("Invalid combination");
      return;
    }

    // 🔥 PAYLOAD (customize as per your API)
    const payload = {
      StartDate: safeFormat(startDate),
      EndDtate: safeFormat(endDate),
      PARTYWISEIds: selectedAccountId ? selectedAccountId.toString() : "",
      selectedIds: selectedProductionId ? selectedProductionId.toString() : "",
      QualityIds: selectedQualityId ? selectedQualityId.toString() : "",
    };

    // 🔥 FINAL DISPATCH
    dispatch(apiFunction(payload));
  };


  useEffect(() => {
    if (!isSubmitted || selected.length === 0) return;

    handleApiCall();
  }, [reportType]);

  useEffect(() => {
    if (selected.length === 0) {
      setIsSubmitted(false);
      setGroupKey("");
    }
  }, [selected]);

  const detailApiMap = {

    // ✅ DAYWISE
    "DateWise": DateWiseDateWiseDtl,
    "DateWise-Partywise": DateWisePartyWiseDtl,
    "DateWise-Itemwise": DateWiseItemWiseDtl,
    "DateWise-Groupwise": DateWiseGroupWiseDtl,
    "DateWise-Bookwise": DateWiseBookWiseDtl,

    // ✅ PARTYWISE
    "Partywise": PartyWisePartyWiseDtl,
    "Partywise-DateWise": PartyWiseDateWiseDtl,
    "Partywise-Itemwise": PartyWiseItemWiseDtl,
    "Partywise-Groupwise": PartyWiseGroupWiseDtl,
    "Partywise-Bookwise": PartyWiseBookWiseDtl,
    "Partywise-Monthwise": PartyWiseMonthWiseDtl,

    // ✅ ITEMWISE
    "Itemwise": ItemWiseItemWiseDtl,
    "Itemwise-DateWise": ItemWiseDateWiseDtl,
    "Itemwise-Partywise": ItemWisePartyWiseDtl,
    "Itemwise-Groupwise": ItemWiseGroupWiseDtl,
    "Itemwise-Bookwise": ItemWiseBookWiseDtl,
    "Itemwise-Monthwise": ItemWiseMonthWiseDtl,

    // ✅ GROUPWISE
    "Groupwise": GroupWiseGroupWiseDtl,
    "Groupwise-DateWise": GroupWiseDateWiseDtl,
    "Groupwise-Partywise": GroupWisePartyWiseDtl,
    "Groupwise-Itemwise": GroupWiseItemWiseDtl,
    "Groupwise-Bookwise": GroupWiseBookWiseDtl,
    "Groupwise-Monthwise": GroupWiseMonthWiseDtl,

    // ✅ BOOKWISE
    "Bookwise": BookWiseBookWiseDtl,
    "Bookwise-DateWise": BookWiseDateWiseDtl,
    "Bookwise-Partywise": BookWisePartyWiseDtl,
    "Bookwise-Itemwise": BookWiseItemWiseDtl,
    "Bookwise-Groupwise": BookWiseGroupWiseDtl,
    "Bookwise-Monthwise": BookWiseMonthWiseDtl,

    // ✅ MONTHWISE
    "Monthwise": MonthWiseMonthWiseDtl,
    "Monthwise-DateWise": MonthWiseMonthWiseDtl,
    "Monthwise-Partywise": MonthWisePartyWiseDtl,
    "Monthwise-Itemwise": MonthWiseItemWiseDtl,
    "Monthwise-Groupwise": MonthWiseGroupWiseDtl,
    "Monthwise-Bookwise": MonthWiseBookWiseDtl,
  };

  const summaryApiMap = {

    // ✅ DAYWISE
    "DateWise": DateWiseDateWiseSumm,
    "DateWise-Partywise": DateWisePartyWiseSumm,
    "DateWise-Itemwise": DateWiseItemWiseSumm,
    "DateWise-Groupwise": DateWiseGroupWiseSumm,
    "DateWise-Bookwise": DateWiseBookWiseSumm,

    // ✅ PARTYWISE
    "Partywise": PartyWisePartyWiseSumm,
    "Partywise-DateWise": PartyWiseDateWiseSumm,
    "Partywise-Itemwise": PartyWiseItemWiseSumm,
    "Partywise-Groupwise": PartyWiseGroupWiseSumm,
    "Partywise-Bookwise": PartyWiseBookWiseSumm,
    "Partywise-Monthwise": PartyWiseMonthWiseSumm,

    // ✅ ITEMWISE
    "Itemwise": ItemWiseItemWiseSumm,
    "Itemwise-DateWise": ItemWiseDateWiseSumm,
    "Itemwise-Partywise": ItemWisePartyWiseSumm,
    "Itemwise-Groupwise": ItemWiseGroupWiseSumm,
    "Itemwise-Bookwise": ItemWiseBookWiseSumm,
    "Itemwise-Monthwise": ItemWiseMonthWiseSumm,

    // ✅ GROUPWISE
    "Groupwise": GroupWiseGroupWiseSumm,
    "Groupwise-DateWise": GroupWiseDateWiseSumm,
    "Groupwise-Partywise": GroupWisePartyWiseSumm,
    "Groupwise-Itemwise": GroupWiseItemWiseSumm,
    "Groupwise-Bookwise": GroupWiseBookWiseSumm,
    "Groupwise-Monthwise": GroupWiseMonthWiseSumm,

    // ✅ BOOKWISE
    "Bookwise": BookWiseBookWiseSumm,
    "Bookwise-DateWise": BookWiseDateWiseSumm,
    "Bookwise-Partywise": BookWisePartyWiseSumm,
    "Bookwise-Itemwise": BookWiseItemWiseSumm,
    "Bookwise-Groupwise": BookWiseGroupWiseSumm,
    "Bookwise-Monthwise": BookWiseMonthWiseSumm,

    // ✅ MONTHWISE
    "Monthwise": MonthWiseMonthWiseSumm,
    "Monthwise-DateWise": MonthWiseMonthWiseSumm,
    "Monthwise-Partywise": MonthWisePartyWiseSumm,
    "Monthwise-Itemwise": MonthWiseItemWiseSumm,
    "Monthwise-Groupwise": MonthWiseGroupWiseSumm,
    "Monthwise-Bookwise": MonthWiseBookWiseSumm,
  };

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const formatIndianRupee1 = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

  const { columns, rows, parentKey, childKey, columns1, rows1 } =
    useMemo(() => {
      let columns = [];
      let rows = [];
      let columns1 = [];
      let rows1 = [];
      let parentKey = "";
      let childKey = "";

      if (GroupKey === "DateWise" && reportType === "detail") {
        parentKey = "InwardDate";

        if (activeInfoButton === "Inward") {
          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "InwardDate",
              label: "InwardDate",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "InwMeter",
              label: "InwMeter",
              align: "right",
              format: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "InwTaka",
              label: "InwTaka",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "AcName",
              label: "Party Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName",
              label: "ItemName",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "LotNo",
              label: "LotNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ChallanNo",
              label: "ChallanNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
          ];

          const arr = DateWiseDateWiseDtlData?.DateWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        } else if (activeInfoButton === "Balance") {
          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "InwardDate",
              label: "InwardDate",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "BalMeter",
              label: "Bal Meter",
              align: "right",
              format: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "BalTaka",
              label: "Bal Taka",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "AcName",
              label: "Party Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName",
              label: "ItemName",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "LotNo",
              label: "LotNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ChallanNo",
              label: "ChallanNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
          ];

          const arr = DateWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        } else if (activeInfoButton === "Delivery") {
          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "DeliveryDate",
              label: "Delivery Date",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "AcName",
              label: "Party Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName",
              label: "Quality Name",
              align: "left",
              format: true,
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "InwardDate",
              label: "Inward Date",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ProductionGroupMstID",
              label: "Gp No",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "DP",
              label: "Process",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ChallanNo",
              label: "ChallanNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "Days",
              label: "Days",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "LotNo",
              label: "LotNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "DlvTaka",
              label: "Delivery Taka",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "DlvTp",
              label: "Tp",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "DlvMeter",
              label: "Delivery Meter",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "DlvRate",
              label: "Rate",
              align: "right",
              format: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "Gst",
              label: "Gst",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "DiscountAmount",
              label: "Discount Amount",
              format: true,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "TaxableAmt",
              label: "Taxable Amount",
              align: "right",
              format: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "NetAmount",
              label: "Net Amount",
              align: "right",
              format: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
          ];

          const Delarr = DateWiseDateWiseDtlData?.DateWiseDlvDtl || [];
          const DeltotalLength = Delarr.length.toString().length;

          rows = Delarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(DeltotalLength, "0"),
            ...row,
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        } else if (activeInfoButton === "Opening") {
          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "InwardDate",
              label: "InwardDate",
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "OpMeter",
              label: "Opening Meter",
              format: true,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "OpTaka",
              label: "Opening Taka",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "AcName",
              label: "Party Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName",
              label: "ItemName",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "LotNo",
              label: "LotNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ChallanNo",
              label: "ChallanNo",
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
          ];

          const Oparr = DateWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const OptotalLength = Oparr.length.toString().length;
          rows = Oparr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(OptotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "DateWise-Partywise" && reportType === "detail") {
        // 🔥 INWARD
        if (activeInfoButton === "Inward") {
          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              width: 150,
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "InwardDate",
              label: "Inward Date",
              width: 130,
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "AcName", label: "Party Name",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName",
              label: "Item Name",
              width: 130,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ChallanNo",
              label: "Challan No.",
              width: 100,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "LotNo",
              label: "Lot No.",
              width: 100,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "InwMeter",
              label: "Inward Meter",
              width: 130,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "InwTaka",
              label: "Inward Taka",
              width: 130,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
              format: true,
            },
          ];

          parentKey = "InwardDate";
          childKey = "AcName";

          const arr = DateWisePartyWiseDtlData?.AcWiseDtl || [];
          const totalLength = arr.length.toString().length;
          rows = DateWisePartyWiseDtlData?.AcWiseDtl?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 BALANCE
        else if (activeInfoButton === "Balance") {
          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              width: 150,
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "InwardDate",
              label: "Inward Date",
              width: 150,
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "AcName",
              label: "Party Name",
              width: 130,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName",
              label: "Item Name",
              width: 150,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "BookTypeName",
              label: "Item Name",
              width: 150,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ChallanNo",
              label: "Challan No.",
              width: 100,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "LotNo",
              label: "Lot No.",
              width: 100,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "BalMeter",
              label: "Balance Meter",
              width: 130,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "BalTaka",
              label: "Balance Taka",
              width: 150,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
          ];

          parentKey = "InwardDate";
          childKey = "AcName";

          const Balarr = DateWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const BaltotalLength = Balarr.length.toString().length;
          rows = Balarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(BaltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        } else if (activeInfoButton === "Delivery") {
          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              width: 150,
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "InwardDate",
              label: "Inward Date",
              width: 150,
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "AcName",
              label: "Party Name",
              width: 130,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName",
              label: "Item Name",
              width: 150,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "BookTypeName",
              label: "Item Name",
              width: 150,
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ChallanNo",
              label: "Challan No.",
              width: 100,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "LotNo",
              label: "Lot No.",
              width: 100,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "OpMeter",
              label: "Opening Meter",
              width: 130,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "OpTaka",
              label: "Opening Taka",
              width: 150,
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
          ];

          parentKey = "InwardDate";
          childKey = "AcName";

          const Oparr = DateWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const OptotalLength = Oparr.length.toString().length;
          rows = Oparr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(OptotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        } else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "DeliveryDate", label: "DeliveryDate", width: 130 },
            { key: "AcName", label: "Party Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
            },
            { key: "ItemName", label: "Quality Name", width: 130 },
            { key: "InwardDate", label: "Inward Date", width: 130 },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130 },
            { key: "DP", label: "Process", width: 130 },
            { key: "ChallanNo", label: "ChallanNo", width: 130 },
            { key: "Days", label: "Days", width: 130 },
            { key: "LotNo", label: "LotNo", width: 130 },
            { key: "DlvTaka", label: "Delivery Taka", width: 130 },
            { key: "DlvTp", label: "Tp", width: 130 },
            { key: "DlvMeter", label: "Delivery Meter", width: 130 },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
            },
            { key: "DlvRate", label: "Rate", width: 130 },
            { key: "Amount", label: "Amount", width: 130 },
            { key: "Gst", label: "Gst", width: 130 },
            { key: "DiscountAmount", label: "Discount Amount", width: 130 },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130 },
            { key: "NetAmount", label: "Net Amount", width: 130 },
          ];

          parentKey = "InwardDate";
          childKey = "AcName";

          const Delarr = DateWisePartyWiseDtlData?.AcWiseOpeningDlvDtl || [];
          const DeltotalLength = Delarr.length.toString().length;

          rows = Delarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(DeltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "DateWise-Itemwise" && reportType === "detail") {
        // 🔥 INWARD
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "AcName", label: "Party Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "ChallanNo", label: "Challan No.", width: 100 },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", format: true },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right" },
          ];

          // ✅ ADD THIS (structure)
          parentKey = "InwardDate";
          childKey = "ItemName";

          const arr = DateWiseItemWiseDtlData?.ItemWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 BALANCE
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "AcName", label: "Party Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "ChallanNo", label: "Challan No.", width: 100 },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", format: true },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", format: true },
          ];

          // ✅ ADD THIS
          parentKey = "InwardDate";
          childKey = "ItemName";

          const Balarr = DateWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const BaltotalLength = Balarr.length.toString().length;

          rows = Balarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(BaltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 DELIVERY
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "DeliveryDate", label: "Delivery Date", width: 130 },
            { key: "ItemName", label: "Quality Name", width: 130 },
            { key: "AcName", label: "Party Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
            },
            { key: "InwardDate", label: "Inward Date", width: 130 },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right" },
            { key: "DP", label: "Process", width: 130 },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right" },
            { key: "Days", label: "Days", width: 130, align: "right" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", format: true },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              format: true
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", format: true },
            { key: "Amount", label: "Amount", width: 130, align: "right", format: true },
            { key: "Gst", label: "Gst", width: 130, align: "right" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", format: true },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", format: true },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", format: true },
          ];

          // ✅ ADD THIS
          parentKey = "InwardDate";
          childKey = "ItemName";

          const Delarr = DateWiseItemWiseDtlData?.ItemWiseOpeningDlvDtl || [];
          const DeltotalLength = Delarr.length.toString().length;

          rows = Delarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(DeltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 OPENING
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "AcName", label: "Party Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "ChallanNo", label: "Challan No.", width: 100 },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Balance Meter", width: 130, format: true, align: "right" },
            { key: "OpTaka", label: "Balance Taka", width: 150, align: "right" },
          ];

          // ✅ ADD THIS
          parentKey = "InwardDate";
          childKey = "ItemName";

          const Oparr = DateWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const OptotalLength = Oparr.length.toString().length;

          rows = Oparr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(OptotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "DateWise-Groupwise" && reportType === "detail") {
        // 🔥 INWARD
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", format: true },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", format: true },
          ];

          // ✅ ADD STRUCTURE
          parentKey = "InwardDate";
          childKey = "ProductionGroupMstName";

          const arr = DateWiseGroupWiseDtlData?.GrpWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 BALANCE
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", format: true },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right" },
          ];

          // ✅ ADD STRUCTURE
          parentKey = "InwardDate";
          childKey = "ProductionGroupMstName";

          const Oparr = DateWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const OptotalLength = Oparr.length.toString().length;

          rows = Oparr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(OptotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 DELIVERY
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "DeliveryDate", label: "Delivery Date", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
            },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ItemName", label: "Quality Name", width: 130 },
            { key: "InwardDate", label: "Inward Date", width: 130 },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right" },
            { key: "DP", label: "Process", width: 130 },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right" },
            { key: "Days", label: "Days", width: 130, align: "right" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", format: true },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              format: true
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", format: true },
            { key: "Amount", label: "Amount", width: 130, align: "right", format: true },
            { key: "Gst", label: "Gst", width: 130, align: "right" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", format: true },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", format: true },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", format: true },
          ];

          // ✅ ADD STRUCTURE
          parentKey = "InwardDate";
          childKey = "ProductionGroupMstName";

          const Delarr = DateWiseGroupWiseDtlData?.GrpWiseOpeningDlvDtl || [];
          const DeltotalLength = Delarr.length.toString().length;

          rows = Delarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(DeltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 OPENING
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", format: true },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", format: true },
          ];

          // ✅ ADD STRUCTURE
          parentKey = "InwardDate";
          childKey = "ProductionGroupMstName";

          const Oparr = DateWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const OptotalLength = Oparr.length.toString().length;

          rows = Oparr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(OptotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "DateWise-Bookwise" && reportType === "detail") {
        // 🔥 INWARD
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            { key: "BookTypeName", label: "Book Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", format: true },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", format: true },
          ];

          // ✅ STRUCTURE
          parentKey = "InwardDate";
          childKey = "BookTypeName";

          const arr = DateWiseBookWiseDtlData?.BookWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 BALANCE
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            { key: "BookTypeName", label: "Book Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", format: true },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", format: true },
          ];

          parentKey = "InwardDate";
          childKey = "BookTypeName";

          const Balarr = DateWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const BaltotalLength = Balarr.length.toString().length;

          rows = Balarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(BaltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 DELIVERY
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "DeliveryDate", label: "Delivery Date", width: 130 },
            { key: "BookTypeName", label: "Book Name", width: 130 },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
            },
            { key: "ItemName", label: "Quality Name", width: 130 },
            { key: "InwardDate", label: "Inward Date", width: 130 },
            { key: "DP", label: "Process", width: 130 },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right" },
            { key: "Days", label: "Days", width: 130, align: "right" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", format: true },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              format: true
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", format: true },
            { key: "Amount", label: "Amount", width: 130, align: "right", format: true },
            { key: "Gst", label: "Gst", width: 130, align: "right" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", format: true },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", format: true },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", format: true },
          ];

          parentKey = "InwardDate";
          childKey = "BookTypeName";

          const Delarr = DateWiseBookWiseDtlData?.BookWiseOpeningDlvDtl || [];
          const DeltotalLength = Delarr.length.toString().length;

          rows = Delarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(DeltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }

        // 🔥 OPENING
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 150 },
            { key: "BookTypeName", label: "Book Name", width: 130 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 150,
            },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "ItemName", label: "Item Name", width: 150 },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", format: true },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right" },
          ];

          parentKey = "InwardDate";
          childKey = "BookTypeName";

          const Oparr = DateWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const OptotalLength = Oparr.length.toString().length;

          rows = Oparr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(OptotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
          }));
        }
      }








      if (GroupKey === "Partywise" && reportType === "detail") {
        parentKey = "AcName";
        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {

          columns = [
            {
              key: "srNumber",
              label: "Sr No.",
              width: 150,
              align: "center",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "ItemName", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "InwMeter", label: "InwMeter", width: 130, colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true", align: "right",
            },
            {
              key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "LotNo",
              label: "LotNo",
              width: 130,
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ChallanNo", label: "ChallanNo", width: 130,
              align: "right",
              rupees: true,
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
          ];

          const arr = PartyWisePartyWiseDtlData?.AcWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
          console.log(rows);
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, format: "true", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalTaka", label: "Balance Taka", width: 150, rupees: "true", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName", label: "ItemName", width: 130, align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
          ];

          const arr = PartyWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpTaka", label: "Opening Taka", width: 150, rupees: "true", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            {
              key: "ItemName", label: "ItemName", width: 130, align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
          ];

          const arr = PartyWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DP", label: "Process", width: 130 },
            { key: "ChallanNo", label: "ChallanNo", width: 130 },
            { key: "DeliveryDate", label: "Delivery Date", width: 130 },
            { key: "Days", label: "Days", width: 130 },
            { key: "LotNo", label: "LotNo", width: 130 },
            { key: "DlvTaka", label: "Delivery Taka", width: 130 },
            { key: "DlvTp", label: "Tp", width: 130 },
            { key: "DlvMeter", label: "Delivery Meter", width: 130 },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
            },
            { key: "DlvRate", label: "Rate", width: 130 },
            { key: "Amount", label: "Amount", width: 130 },
            { key: "Gst", label: "Gst", width: 130 },
            { key: "DiscountAmount", label: "Discount Amount", width: 130 },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130 },
            { key: "NetAmount", label: "Net Amount", width: 130 },
          ];

          const arr = PartyWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Partywise-DateWise" && reportType === "detail") {
        parentKey = "AcName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "ItemName", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, rupees: "true", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ChallanNo", label: "ChallanNo", width: 130, rupees: "true", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, align: "right" },
          ];

          const arr = PartyWiseDateWiseDtlData?.DateWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "InwardDate", label: "InwardDate", width: 150, aign: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2
            },
            { key: "ItemName", label: "ItemName", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          const arr = PartyWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          const arr = PartyWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", rupees: "true", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", rupees: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              format: "true",
              colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const Delarr = PartyWiseDateWiseDtlData?.DateWiseOpeningDlvDtl || [];
          const DeltotalLength = Delarr.length.toString().length;
          rows = Delarr?.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(DeltotalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Partywise-Itemwise" && reportType === "detail") {
        parentKey = "AcName";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No." },
            { key: "AcName", label: "Party Name", align: "left" },
            { key: "ItemName", label: "Quality Name", align: "left" },
            {
              key: "InwardDate",
              label: "InwardDate",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "InwMeter",
              label: "Iward Meter",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "InwTaka",
              label: "Inward Taka",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "LotNo",
              label: "LotNo",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ChallanNo",
              label: "ChallanNo",
              align: "right",
              colors:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              align: "left",
              colors:
                isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
          ];

          const arr = PartyWiseItemWiseDtlData?.ItemWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Production Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Production Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Production Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", alin: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DP", label: "Process", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvFinishShortageMeter_N", label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DlvRate", label: "Rate", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseItemWiseDtlData?.ItemWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Partywise-Groupwise" && reportType === "detail") {
        parentKey = "AcName";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseGroupWiseDtlData?.GrpWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,

            },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
              format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseGroupWiseDtlData?.GrpWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Partywise-Bookwise" && reportType === "detail") {
        parentKey = "AcName";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseBookWiseDtlData?.BookWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = PartyWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
              format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseBookWiseDtlData?.BookWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Partywise-Monthwise" && reportType === "detail") {
        parentKey = "AcName";
        childKey = "Month_Name";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = PartyWiseMonthWiseDtlData?.MonthWiseDtl || [];

          const financialYearOrder = [
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            "January",
            "February",
            "March",
          ];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_Taka`, label: `${month} Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_Meter`, label: `${month} Meter`, width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const { AcName, Month_Name, InwTaka, InwMeter } = item;

            if (!groupedData[AcName]) {
              groupedData[AcName] = { AcName };

              uniqueMonths.forEach((m) => {
                groupedData[AcName][`${m}_Taka`] = "0";
                groupedData[AcName][`${m}_Meter`] = "0.00";
              });
            }

            groupedData[AcName][`${Month_Name}_Taka`] =
              formatIndianRupee1(InwTaka);
            groupedData[AcName][`${Month_Name}_Meter`] =
              formatIndianRupee(InwMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = PartyWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group",
              width: 180,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 180, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "LotNo", label: "LotNo", width: 120, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 120, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          rawMonths.forEach((m) => {
            columns.push(
              { key: `${m}_BalTaka`, label: `${m} Bal Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${m}_BalMeter`, label: `${m} Bal Meter`, width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const {
              AcName,
              ProductionGroupMstName,
              ItemName,
              LotNo,
              ChallanNo,
              Month_Name,
              BalTaka,
              BalMeter,
            } = item;

            const key = `${AcName}_${ProductionGroupMstName}_${ItemName}_${LotNo}_${ChallanNo}`;

            if (!groupedData[key]) {
              groupedData[key] = {
                AcName,
                ProductionGroupMstName,
                ItemName,
                LotNo,
                ChallanNo,
              };

              rawMonths.forEach((m) => {
                groupedData[key][`${m}_BalTaka`] = "0";
                groupedData[key][`${m}_BalMeter`] = "0.00";
              });
            }

            groupedData[key][`${Month_Name}_BalTaka`] =
              formatIndianRupee1(BalTaka);
            groupedData[key][`${Month_Name}_BalMeter`] =
              formatIndianRupee(BalMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        } else if (activeInfoButton === "Opening") {
          const arr = PartyWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];

          const financialYearOrder = [
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            "January",
            "February",
            "March",
          ];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group",
              width: 180,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 180, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "LotNo", label: "LotNo", width: 120, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 120, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          uniqueMonths.forEach((m) => {
            columns.push(
              { key: `${m}_OpTaka`, label: `${m} Op Taka`, width: 160 },
              { key: `${m}_OpMeter`, label: `${m} Op Meter`, width: 180 },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const {
              AcName,
              ProductionGroupMstName,
              ItemName,
              LotNo,
              ChallanNo,
              Month_Name,
              OpTaka,
              OpMeter,
            } = item;

            const key = `${AcName}_${ProductionGroupMstName}_${ItemName}_${LotNo}_${ChallanNo}`;

            if (!groupedData[key]) {
              groupedData[key] = {
                AcName,
                ProductionGroupMstName,
                ItemName,
                LotNo,
                ChallanNo,
              };

              uniqueMonths.forEach((m) => {
                groupedData[key][`${m}_OpTaka`] = "0";
                groupedData[key][`${m}_OpMeter`] = "0.00";
              });
            }

            groupedData[key][`${Month_Name}_OpTaka`] =
              formatIndianRupee1(OpTaka);
            groupedData[key][`${Month_Name}_OpMeter`] =
              formatIndianRupee(OpMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
              format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseMonthWiseDtlData?.MonthWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Itemwise" && reportType === "detail") {
        parentKey = "ItemName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
          ];

          const arr = ItemWiseItemWiseDtlData?.ItemWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
          ];

          const arr = ItemWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
          ];

          const arr = ItemWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left",
              colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
              format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
          ];

          const arr = ItemWiseItemWiseDtlData?.ItemWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Itemwise-DateWise" && reportType === "detail") {
        parentKey = "ItemName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true", },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseDateWiseDtlData?.DateWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true", },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true", },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, ruppes: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = ItemWiseDateWiseDtlData?.DateWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Itemwise-Partywise" && reportType === "detail") {
        parentKey = "ItemName";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "InwMeter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwTaka", label: "InwTaka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWisePartyWiseDtlData?.AcWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left ", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, ruppes: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = ItemWisePartyWiseDtlData?.AcWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Itemwise-Groupwise" && reportType === "detail") {
        parentKey = "ItemName";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseGroupWiseDtlData?.GrpWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, ruppes: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, alin: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = ItemWiseGroupWiseDtlData?.GrpWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Itemwise-Bookwise" && reportType === "detail") {
        parentKey = "ItemName";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, aligb: "right ", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseBookWiseDtlData?.BookWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, alugn: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, alin: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "right" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, fomat: "true" },
          ];

          const arr = ItemWiseBookWiseDtlData?.BookWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Itemwise-Monthwise" && reportType === "detail") {
        parentKey = "ItemName";
        childKey = "Month_Name";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = ItemWiseMonthWiseDtlData?.MonthWiseDtl || [];

          const financialYearOrder = [
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            "January",
            "February",
            "March",
          ];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_Taka`, label: `${month} Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
              { key: `${month}_Meter`, label: `${month} Meter`, width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const { ItemName, AcName, Month_Name, InwTaka, InwMeter } = item;
            const key = `${ItemName}_${AcName}`;

            if (!groupedData[key]) {
              groupedData[key] = { ItemName, AcName };

              uniqueMonths.forEach((m) => {
                groupedData[key][`${m}_Taka`] = "0";
                groupedData[key][`${m}_Meter`] = "0.00";
              });
            }

            groupedData[key][`${Month_Name}_Taka`] =
              formatIndianRupee1(InwTaka);
            groupedData[key][`${Month_Name}_Meter`] =
              formatIndianRupee(InwMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = ItemWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const financialYearOrder = [
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            "January",
            "February",
            "March",
          ];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          uniqueMonths.forEach((m) => {
            columns.push(
              { key: `${m}_BalMeter`, label: `${m} Bal Meter`, width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${m}_BalTaka`, label: `${m} Bal Taka`, width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const {
              AcName,
              ProductionGroupMstName,
              ItemName,
              LotNo,
              ChallanNo,
              Month_Name,
              BalTaka,
              BalMeter,
            } = item;

            const key = `${AcName}_${ProductionGroupMstName}_${ItemName}_${LotNo}_${ChallanNo}`;

            if (!groupedData[key]) {
              groupedData[key] = {
                AcName,
                ProductionGroupMstName,
                ItemName,
                LotNo,
                ChallanNo,
              };

              uniqueMonths.forEach((m) => {
                groupedData[key][`${m}_BalTaka`] = "0";
                groupedData[key][`${m}_BalMeter`] = "0.00";
              });
            }

            groupedData[key][`${Month_Name}_BalTaka`] =
              formatIndianRupee1(BalTaka);
            groupedData[key][`${Month_Name}_BalMeter`] =
              formatIndianRupee(BalMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = ItemWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = ItemWiseMonthWiseDtlData?.MonthWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Groupwise" && reportType === "detail") {
        parentKey = "ProductionGroupMstName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseGroupWiseDtlData?.GrpWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center" },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, ruees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
              format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = GroupWiseGroupWiseDtlData?.GrpWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Groupwise-DateWise" && reportType === "detail") {
        parentKey = "ProductionGroupMstName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 15, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseDateWiseDtlData?.DateWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
              format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = GroupWiseDateWiseDtlData?.DateWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Groupwise-Partywise" && reportType === "detail") {
        parentKey = "ProductionGroupMstName";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWisePartyWiseDtlData?.AcWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = GroupWisePartyWiseDtlData?.AcWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Groupwise-Itemwise" && reportType === "detail") {
        parentKey = "ProductionGroupMstName";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseItemWiseDtlData?.ItemWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = GroupWiseItemWiseDtlData?.ItemWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Groupwise-Bookwise" && reportType === "detail") {
        parentKey = "ProductionGroupMstName";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseBookWiseDtlData?.BookWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = GroupWiseBookWiseDtlData?.BookWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Groupwise-Monthwise" && reportType === "detail") {
        parentKey = "ProductionGroupMstName";
        childKey = "Month_Name";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseMonthWiseDtlData?.MonthWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = GroupWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = GroupWiseMonthWiseDtlData?.MonthWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Bookwise" && reportType === "detail") {
        parentKey = "BookTypeName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseBookWiseDtlData?.BookWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right",
              colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = BookWiseBookWiseDtlData?.BookWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Bookwise-DateWise" && reportType === "detail") {
        parentKey = "BookTypeName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseDateWiseDtlData?.DateWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseDateWiseDtlData?.DateWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left"
              , colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = BookWiseDateWiseDtlData?.DateWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Bookwise-Partywise" && reportType === "detail") {
        parentKey = "BookTypeName";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, alin: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWisePartyWiseDtlData?.AcWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = BookWisePartyWiseDtlData?.AcWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Bookwise-Itemwise" && reportType === "detail") {
        parentKey = "BookTypeName";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseItemWiseDtlData?.ItemWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = BookWiseItemWiseDtlData?.ItemWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Bookwise-Groupwise" && reportType === "detail") {
        parentKey = "BookTypeName";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseGroupWiseDtlData?.GrpWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left"
              , colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = BookWiseGroupWiseDtlData?.GrpWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Bookwise-Monthwise" && reportType === "detail") {
        parentKey = "BookTypeName";
        childKey = "Month_Name";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseMonthWiseDtlData?.MonthWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 13, akugn: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = BookWiseMonthWiseDtlData?.MonthWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Bookwise-Monthwise" && reportType === "detail") {
        parentKey = "BookTypeName";
        childKey = "Month_Name";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "true", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, format: "true" },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseMonthWiseDtlData?.MonthWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "right" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "right" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = BookWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Monthwise" && reportType === "detail") {
        parentKey = "Month_Name";
        childKey = "Month_Name";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseMonthWiseDtlData?.MonthWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseMonthWiseDtlData?.MonthWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = MonthWiseMonthWiseDtlData?.MonthWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Monthwise-Partywise" && reportType === "detail") {
        parentKey = "Month_Name";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWisePartyWiseDtlData?.AcWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 150, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWisePartyWiseDtlData?.AcWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 13, align: "true", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = MonthWisePartyWiseDtlData?.AcWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Monthwise-Itemwise" && reportType === "detail") {
        parentKey = "Month_Name";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseItemWiseDtlData?.ItemWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseItemWiseDtlData?.ItemWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
            },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = MonthWiseItemWiseDtlData?.ItemWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Monthwise-Groupwise" && reportType === "detail") {
        parentKey = "Month_Name";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseGroupWiseDtlData?.GrpWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "OpMeter", label: "Opening Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "OpTaka", label: "Opening Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseGroupWiseDtlData?.GrpWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "right" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "right" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = MonthWiseGroupWiseDtlData?.GrpWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "Monthwise-Bookwise" && reportType === "detail") {
        parentKey = "Month_Name";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwMeter", label: "Inward Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "InwTaka", label: "Inward Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseBookWiseDtlData?.BookWiseDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, ruppes: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, rupees: "true" },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BalMeter", label: "Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "BalTaka", label: "Balance Taka", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "ChallanNo", label: "Challan No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "LotNo", label: "Lot No.", width: 100, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "ProductionGroupMstName", label: "Group Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 100, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          const arr = MonthWiseBookWiseDtlData?.BookWiseOpeningDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130
              , align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstID", label: "Gp No", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DP", label: "Process", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ChallanNo", label: "ChallanNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Days", label: "Days", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "LotNo", label: "LotNo", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "DlvRate", label: "Rate", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = MonthWiseBookWiseDtlData?.BookWiseOpeningDlvDtl || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
          }));
        }
      }

      if (GroupKey === "DateWise" && reportType === "summary") {
        parentKey = "InwardDate";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotBalTaka", label: "Total Balance Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "InwardDate", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotOpwTaka", label: "Total Balance Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, ruppes: "true" },
            { key: "TotOpwMeter", label: "Total Balance Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
          ];

          const arr = DateWiseDateWiseSummData?.DateWiseDatewiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "DateWise-Partywise" && reportType === "summary") {
        parentKey = "InwardDate";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
          ];

          const arr = DateWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
          ];

          const arr = DateWisePartyWiseSummData?.MainAcWiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            AcName: row.AcName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "DateWise-Itemwise" && reportType === "summary") {
        parentKey = "InwardDate";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Item Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Item Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseItemWiseSummData?.MainItemwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            ItemName: row.ItemName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "DateWise-Groupwise" && reportType === "summary") {
        parentKey = "InwardDate";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130,
              align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          const arr = DateWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            {
              key: "ProductionGroupMstName",
              label: "Production Group Name",
              width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
            },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130
              , align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseGroupWiseSummData?.MainGrpwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            ProductionGroupMstName: row.ProductionGroupMstName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "DateWise-Bookwise" && reportType === "summary") {
        parentKey = "InwardDate";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = DateWiseBookWiseSummData?.MainBookwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            BookTypeName: row.BookTypeName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Partywise" && reportType === "summary") {

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "InwardDate", label: "Inward Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];



          const arr = PartyWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "InwardDate", label: "Inward Date", width: 130 },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130 },
            { key: "TotOpwMeter", label: "Total Meter", width: 130 },
          ];


          const arr = PartyWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150 },
            { key: "AcName", label: "Party Name", width: 130 },
            { key: "DlvTp", label: "Tp", width: 130 },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130 },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130 },
            { key: "DlvFinishShortageMeter_N", label: "Shortage Meter", width: 130 },
            { key: "Amount", label: "Amount", width: 130 },
            { key: "Gst", label: "Gst", width: 130 },
            { key: "DiscountAmount", label: "Discount Amount", width: 130 },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130 },
            { key: "NetAmount", label: "Net Amount", width: 130 },
          ];


          const arr = PartyWisePartyWiseSummData?.MainAcwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            AcName: row.AcName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(row.DlvFinishShortageMeter_N),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Partywise-DateWise" && reportType === "summary") {
        parentKey = "AcName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseDateWiseSummData?.MainDatewiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            AcName: row.AcName,
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Partywise-Itemwise" && reportType === "summary") {
        parentKey = "AcName";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Item Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseItemWiseSummData?.MainItemwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            AcName: row.AcName,
            ItemName: row.ItemName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Partywise-Groupwise" && reportType === "summary") {
        parentKey = "AcName";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseGroupWiseSummData?.MainGrpwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            AcName: row.AcName,
            ProductionGroupMstName: row.ProductionGroupMstName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Partywise-Bookwise" && reportType === "summary") {
        parentKey = "AcName";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          const arr = PartyWiseBookWiseSummData?.MainBookwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            AcName: row.AcName,
            BookTypeName: row.BookTypeName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Partywise-Monthwise" && reportType === "summary") {
        parentKey = "AcName";
        childKey = "Month_Name";

        const financialYearOrder = [
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
          "January",
          "February",
          "March",
        ];

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = PartyWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns1.push(
              { key: `${month}_Taka`, label: `${month} Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_Meter`, label: `${month} Meter`, width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const { AcName, Month_Name, TotInwTaka, TotInwMeter } = item;

            if (!groupedData[AcName]) {
              groupedData[AcName] = { AcName };

              uniqueMonths.forEach((month) => {
                groupedData[AcName][`${month}_Taka`] = "0";
                groupedData[AcName][`${month}_Meter`] = "0.00";
              });
            }

            groupedData[AcName][`${Month_Name}_Taka`] =
              formatIndianRupee1(TotInwTaka);
            groupedData[AcName][`${Month_Name}_Meter`] =
              formatIndianRupee(TotInwMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows1 = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = PartyWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              {
                key: `${month}_BalTaka`,
                label: `${month} Bal Taka`,
                width: 160,
                align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true"
              },
              {
                key: `${month}_BalMeter`,
                label: `${month} Bal Meter`,
                width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
              },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const { AcName, Month_Name, TotBalTaka, TotBalMeter } = item;

            if (!groupedData[AcName]) {
              groupedData[AcName] = { AcName };

              uniqueMonths.forEach((month) => {
                groupedData[AcName][`${month}_BalTaka`] = "0";
                groupedData[AcName][`${month}_BalMeter`] = "0.00";
              });
            }

            groupedData[AcName][`${Month_Name}_BalTaka`] =
              formatIndianRupee1(TotBalTaka);
            groupedData[AcName][`${Month_Name}_BalMeter`] =
              formatIndianRupee(TotBalMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = PartyWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_OpTaka`, label: `${month} Op Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              {
                key: `${month}_OpMeter`,
                label: `${month} Op Meter`,
                width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
              },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const { AcName, Month_Name, TotOpwTaka, TotOpwMeter } = item;

            if (!groupedData[AcName]) {
              groupedData[AcName] = { AcName };

              uniqueMonths.forEach((month) => {
                groupedData[AcName][`${month}_OpTaka`] = "0";
                groupedData[AcName][`${month}_OpMeter`] = "0.00";
              });
            }

            groupedData[AcName][`${Month_Name}_OpTaka`] =
              formatIndianRupee1(TotOpwTaka);
            groupedData[AcName][`${Month_Name}_OpMeter`] =
              formatIndianRupee(TotOpwMeter);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = PartyWiseMonthWiseSummData?.MainMonthwiseDlvSum || [];

          const rawMonths = [...new Set(arr.map((item) => item.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 200, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_DlvTaka`, label: `${month} Delivery Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_DlvMeter`, label: `${month} Delivery Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_Amount`, label: `${month} Amount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_NetAmount`, label: `${month} Net Amount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const groupedData = {};

          arr.forEach((item) => {
            const { AcName, Month_Name, DlvTaka, DlvMeter, Amount, NetAmount } =
              item;

            if (!groupedData[AcName]) {
              groupedData[AcName] = { AcName };

              uniqueMonths.forEach((month) => {
                groupedData[AcName][`${month}_DlvTaka`] = "0";
                groupedData[AcName][`${month}_DlvMeter`] = "0.00";
                groupedData[AcName][`${month}_Amount`] = "0";
                groupedData[AcName][`${month}_NetAmount`] = "0";
              });
            }

            groupedData[AcName][`${Month_Name}_DlvTaka`] =
              formatIndianRupee1(DlvTaka);
            groupedData[AcName][`${Month_Name}_DlvMeter`] =
              formatIndianRupee(DlvMeter);
            groupedData[AcName][`${Month_Name}_Amount`] =
              formatIndianRupee1(Amount);
            groupedData[AcName][`${Month_Name}_NetAmount`] =
              formatIndianRupee1(NetAmount);
          });

          const allRows = Object.values(groupedData);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }
      }

      if (GroupKey === "Itemwise" && reportType === "summary") {
        parentKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = ItemWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = ItemWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = ItemWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = ItemWiseItemWiseSummData?.MainItemwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Item Name", width: 130 },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130
              , align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            AcName: row.AcName,
            ItemName: row.ItemName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Partywise-DateWise" && reportType === "summary") {
        parentKey = "AcName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = PartyWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 150, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = PartyWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = PartyWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = PartyWiseDateWiseSummData?.MainDatewiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            AcName: row.AcName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Itemwise-Partywise" && reportType === "summary") {
        parentKey = "ItemName";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = ItemWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = ItemWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = ItemWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = ItemWisePartyWiseSummData?.MainAcwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ItemName: row.ItemName,
            AcName: row.AcName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Itemwise-Groupwise" && reportType === "summary") {
        parentKey = "ItemName";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = ItemWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = ItemWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = ItemWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = ItemWiseGroupWiseSummData?.MainGrpwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130,
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ItemName: row.ItemName,
            ProductionGroupMstName: row.ProductionGroupMstName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Itemwise-Bookwise" && reportType === "summary") {
        parentKey = "ItemName";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = ItemWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = ItemWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = ItemWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = ItemWiseBookWiseSummData?.MainBookwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Item Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ItemName: row.ItemName,
            BookTypeName: row.BookTypeName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Itemwise-Monthwise" && reportType === "summary") {
        parentKey = "ItemName";
        childKey = "Month_Name";

        const financialYearOrder = [
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
          "January",
          "February",
          "March",
        ];

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = ItemWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns1.push(
              { key: `${month}_Taka`, label: `${month} Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_Meter`, label: `${month} Meter`, width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const { ItemName, Month_Name, TotInwTaka, TotInwMeter } = item;

            if (!grouped[ItemName]) {
              grouped[ItemName] = { ItemName };

              uniqueMonths.forEach((m) => {
                grouped[ItemName][`${m}_Taka`] = "0";
                grouped[ItemName][`${m}_Meter`] = "0";
              });
            }

            grouped[ItemName][`${Month_Name}_Taka`] =
              formatIndianRupee1(TotInwTaka);
            grouped[ItemName][`${Month_Name}_Meter`] =
              formatIndianRupee(TotInwMeter);
          });

          rows1 = Object.values(grouped).map((row, i) => ({
            id: i,
            srNumber: i + 1,
            ...row,
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = ItemWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              {
                key: `${month}_BalTaka`,
                label: `${month} Bal Taka`,
                width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true"
              },
              {
                key: `${month}_BalMeter`,
                label: `${month} Bal Meter`,
                width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
              },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const { ItemName, Month_Name, TotBalTaka, TotBalMeter } = item;

            if (!grouped[ItemName]) {
              grouped[ItemName] = { ItemName };

              uniqueMonths.forEach((m) => {
                grouped[ItemName][`${m}_BalTaka`] = "0";
                grouped[ItemName][`${m}_BalMeter`] = "0";
              });
            }

            grouped[ItemName][`${Month_Name}_BalTaka`] =
              formatIndianRupee1(TotBalTaka);
            grouped[ItemName][`${Month_Name}_BalMeter`] =
              formatIndianRupee(TotBalMeter);
          });

          rows = Object.values(grouped).map((row, i) => ({
            id: i,
            srNumber: i + 1,
            ...row,
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = ItemWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_OpTaka`, label: `${month} Op Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              {
                key: `${month}_OpMeter`,
                label: `${month} Op Meter`,
                width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
              },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const { ItemName, Month_Name, TotOpwTaka, TotOpwMeter } = item;

            if (!grouped[ItemName]) {
              grouped[ItemName] = { ItemName };

              uniqueMonths.forEach((m) => {
                grouped[ItemName][`${m}_OpTaka`] = "0";
                grouped[ItemName][`${m}_OpMeter`] = "0";
              });
            }

            grouped[ItemName][`${Month_Name}_OpTaka`] =
              formatIndianRupee1(TotOpwTaka);
            grouped[ItemName][`${Month_Name}_OpMeter`] =
              formatIndianRupee(TotOpwMeter);
          });

          rows = Object.values(grouped).map((row, i) => ({
            id: i,
            srNumber: i + 1,
            ...row,
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = ItemWiseMonthWiseSummData?.MainMonthwiseDlvSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ItemName", label: "Item Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_DlvTp`, label: `${month} Tp`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_DlvTaka`, label: `${month} Delivery Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_DlvMeter`, label: `${month} Delivery Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              {
                key: `${month}_DlvFinishShortageMeter_N`,
                label: `${month} Shortage`
                , align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
              },
              { key: `${month}_Amount`, label: `${month} Amount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_Gst`, label: `${month} Gst`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_DiscountAmount`, label: `${month} Discount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_TaxableAmt`, label: `${month} Taxable`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_NetAmount`, label: `${month} Net, align:"right",colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,format:"true"` },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const {
              ItemName,
              Month_Name,
              DlvTp,
              DlvTaka,
              DlvMeter,
              DlvFinishShortageMeter_N,
              Amount,
              Gst,
              DiscountAmount,
              TaxableAmt,
              NetAmount,
            } = item;

            if (!grouped[ItemName]) {
              grouped[ItemName] = { ItemName };

              uniqueMonths.forEach((m) => {
                grouped[ItemName][`${m}_DlvTp`] = "0";
                grouped[ItemName][`${m}_DlvTaka`] = "0";
                grouped[ItemName][`${m}_DlvMeter`] = "0";
                grouped[ItemName][`${m}_DlvFinishShortageMeter_N`] = "0";
                grouped[ItemName][`${m}_Amount`] = "0";
                grouped[ItemName][`${m}_Gst`] = "0";
                grouped[ItemName][`${m}_DiscountAmount`] = "0";
                grouped[ItemName][`${m}_TaxableAmt`] = "0";
                grouped[ItemName][`${m}_NetAmount`] = "0";
              });
            }

            grouped[ItemName][`${Month_Name}_DlvTp`] =
              formatIndianRupee1(DlvTp);
            grouped[ItemName][`${Month_Name}_DlvTaka`] =
              formatIndianRupee1(DlvTaka);
            grouped[ItemName][`${Month_Name}_DlvMeter`] =
              formatIndianRupee(DlvMeter);
            grouped[ItemName][`${Month_Name}_DlvFinishShortageMeter_N`] =
              formatIndianRupee(DlvFinishShortageMeter_N);
            grouped[ItemName][`${Month_Name}_Amount`] =
              formatIndianRupee1(Amount);
            grouped[ItemName][`${Month_Name}_Gst`] = formatIndianRupee1(Gst);
            grouped[ItemName][`${Month_Name}_DiscountAmount`] =
              formatIndianRupee1(DiscountAmount);
            grouped[ItemName][`${Month_Name}_TaxableAmt`] =
              formatIndianRupee1(TaxableAmt);
            grouped[ItemName][`${Month_Name}_NetAmount`] =
              formatIndianRupee1(NetAmount);
          });

          rows = Object.values(grouped).map((row, i) => ({
            id: i,
            srNumber: i + 1,
            ...row,
          }));
        }
      }

      if (GroupKey === "Groupwise" && reportType === "summary") {
        parentKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = GroupWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = GroupWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = GroupWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = GroupWiseGroupWiseSummData?.MainGrpwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ProductionGroupMstName: row.ProductionGroupMstName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Groupwise-DateWise" && reportType === "summary") {
        parentKey = "ProductionGroupMstName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = GroupWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = GroupWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = GroupWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "InwardDate", label: "Inward Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = GroupWiseDateWiseSummData?.MainDatewiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DeliveryDate", label: "Delivery Date", width: 130, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            ProductionGroupMstName: row.ProductionGroupMstName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Groupwise-Partywise" && reportType === "summary") {
        parentKey = "ProductionGroupMstName";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = GroupWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = GroupWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = GroupWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = GroupWisePartyWiseSummData?.MainAcwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "AcName", label: "Party Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ProductionGroupMstName: row.ProductionGroupMstName,
            AcName: row.AcName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Groupwise-Itemwise" && reportType === "summary") {
        parentKey = "ProductionGroupMstName";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = GroupWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = GroupWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = GroupWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "ItemName", label: "Quality Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = GroupWiseItemWiseSummData?.MainItemwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "ItemName", label: "Item Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130
              , align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ProductionGroupMstName: row.ProductionGroupMstName,
            ItemName: row.ItemName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }


      if (GroupKey === "Groupwise-Bookwise" && reportType === "summary") {

        parentKey = "ProductionGroupMstName";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {

          const arr = GroupWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotInwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = GroupWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotBalTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = GroupWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = GroupWiseBookWiseSummData?.MainBookwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", width: 150, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "BookTypeName", label: "Book Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "DlvTp", label: "Tp", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "Gst", label: "Gst", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "NetAmount", label: "Net Amount", width: 130, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ProductionGroupMstName: row.ProductionGroupMstName,
            BookTypeName: row.BookTypeName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Groupwise-Monthwise" && reportType === "summary") {
        parentKey = "ProductionGroupMstName";
        childKey = "Month_Name";

        const financialYearOrder = [
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
          "January",
          "February",
          "March",
        ];

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = GroupWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns1 = [
            { key: "srNumber", label: "Sr No.", width: 100, align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
          ];

          uniqueMonths.forEach((month) => {
            columns1.push(
              { key: `${month}_Taka`, label: `${month} Taka`, width: 160, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_Meter`, label: `${month} Meter`, width: 180, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const {
              ProductionGroupMstName,
              Month_Name,
              TotInwTaka,
              TotInwMeter,
            } = item;

            if (!grouped[ProductionGroupMstName]) {
              grouped[ProductionGroupMstName] = { ProductionGroupMstName };

              uniqueMonths.forEach((m) => {
                grouped[ProductionGroupMstName][`${m}_Taka`] = "0";
                grouped[ProductionGroupMstName][`${m}_Meter`] = "0";
              });
            }

            grouped[ProductionGroupMstName][`${Month_Name}_Taka`] =
              formatIndianRupee1(TotInwTaka);
            grouped[ProductionGroupMstName][`${Month_Name}_Meter`] =
              formatIndianRupee(TotInwMeter);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows1 = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = GroupWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_BalTaka`, label: `${month} Bal Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_BalMeter`, label: `${month} Bal Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const {
              ProductionGroupMstName,
              Month_Name,
              TotBalTaka,
              TotBalMeter,
            } = item;

            if (!grouped[ProductionGroupMstName]) {
              grouped[ProductionGroupMstName] = { ProductionGroupMstName };

              uniqueMonths.forEach((m) => {
                grouped[ProductionGroupMstName][`${m}_BalTaka`] = "0";
                grouped[ProductionGroupMstName][`${m}_BalMeter`] = "0";
              });
            }

            grouped[ProductionGroupMstName][`${Month_Name}_BalTaka`] =
              formatIndianRupee1(TotBalTaka);
            grouped[ProductionGroupMstName][`${Month_Name}_BalMeter`] =
              formatIndianRupee(TotBalMeter);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = GroupWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_OpTaka`, label: `${month} Op Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_OpMeter`, label: `${month} Op Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const {
              ProductionGroupMstName,
              Month_Name,
              TotOpwTaka,
              TotOpwMeter,
            } = item;

            if (!grouped[ProductionGroupMstName]) {
              grouped[ProductionGroupMstName] = { ProductionGroupMstName };

              uniqueMonths.forEach((m) => {
                grouped[ProductionGroupMstName][`${m}_OpTaka`] = "0";
                grouped[ProductionGroupMstName][`${m}_OpMeter`] = "0";
              });
            }

            grouped[ProductionGroupMstName][`${Month_Name}_OpTaka`] =
              formatIndianRupee1(TotOpwTaka);
            grouped[ProductionGroupMstName][`${Month_Name}_OpMeter`] =
              formatIndianRupee(TotOpwMeter);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = GroupWiseMonthWiseSummData?.MainMonthwiseDlvSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_DlvTp`, label: `${month} Tp`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_DlvTaka`, label: `${month} Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_DlvMeter`, label: `${month} Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              {
                key: `${month}_DlvFinishShortageMeter_N`,
                label: `${month} Shortage`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
              },
              { key: `${month}_Amount`, label: `${month} Amount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_Gst`, label: `${month} Gst`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_DiscountAmount`, label: `${month} Discount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_TaxableAmt`, label: `${month} Taxable`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_NetAmount`, label: `${month} Net`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const {
              ProductionGroupMstName,
              Month_Name,
              DlvTp,
              DlvTaka,
              DlvMeter,
              DlvFinishShortageMeter_N,
              Amount,
              Gst,
              DiscountAmount,
              TaxableAmt,
              NetAmount,
            } = item;

            if (!grouped[ProductionGroupMstName]) {
              grouped[ProductionGroupMstName] = { ProductionGroupMstName };

              uniqueMonths.forEach((m) => {
                grouped[ProductionGroupMstName][`${m}_DlvTp`] = "0";
                grouped[ProductionGroupMstName][`${m}_DlvTaka`] = "0";
                grouped[ProductionGroupMstName][`${m}_DlvMeter`] = "0";
                grouped[ProductionGroupMstName][
                  `${m}_DlvFinishShortageMeter_N`
                ] = "0";
                grouped[ProductionGroupMstName][`${m}_Amount`] = "0";
                grouped[ProductionGroupMstName][`${m}_Gst`] = "0";
                grouped[ProductionGroupMstName][`${m}_DiscountAmount`] = "0";
                grouped[ProductionGroupMstName][`${m}_TaxableAmt`] = "0";
                grouped[ProductionGroupMstName][`${m}_NetAmount`] = "0";
              });
            }

            grouped[ProductionGroupMstName][`${Month_Name}_DlvTp`] =
              formatIndianRupee1(DlvTp);
            grouped[ProductionGroupMstName][`${Month_Name}_DlvTaka`] =
              formatIndianRupee1(DlvTaka);
            grouped[ProductionGroupMstName][`${Month_Name}_DlvMeter`] =
              formatIndianRupee(DlvMeter);
            grouped[ProductionGroupMstName][
              `${Month_Name}_DlvFinishShortageMeter_N`
            ] = formatIndianRupee(DlvFinishShortageMeter_N);
            grouped[ProductionGroupMstName][`${Month_Name}_Amount`] =
              formatIndianRupee1(Amount);
            grouped[ProductionGroupMstName][`${Month_Name}_Gst`] =
              formatIndianRupee1(Gst);
            grouped[ProductionGroupMstName][`${Month_Name}_DiscountAmount`] =
              formatIndianRupee1(DiscountAmount);
            grouped[ProductionGroupMstName][`${Month_Name}_TaxableAmt`] =
              formatIndianRupee1(TaxableAmt);
            grouped[ProductionGroupMstName][`${Month_Name}_NetAmount`] =
              formatIndianRupee1(NetAmount);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }
      }

      if (GroupKey === "Bookwise" && reportType === "summary") {
        parentKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = BookWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = BookWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = BookWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = BookWiseBookWiseSummData?.MainBookwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            BookTypeName: row.BookTypeName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Bookwise-DateWise" && reportType === "summary") {
        parentKey = "BookTypeName";
        childKey = "InwardDate";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = BookWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = BookWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = BookWiseDateWiseSummData?.DateWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "InwardDate", label: "Inward Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            InwardDate: new Date(row.InwardDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = BookWiseDateWiseSummData?.MainDatewiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DeliveryDate", label: "Delivery Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            DeliveryDate: new Date(row.DeliveryDate)
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-"),
            BookTypeName: row.BookTypeName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Bookwise-Partywise" && reportType === "summary") {
        parentKey = "BookTypeName";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = BookWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = BookWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = BookWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = BookWisePartyWiseSummData?.MainAcwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            BookTypeName: row.BookTypeName,
            AcName: row.AcName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Bookwise-Itemwise" && reportType === "summary") {
        parentKey = "BookTypeName";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = BookWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = BookWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = BookWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = BookWiseItemWiseSummData?.MainItemwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Item Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            BookTypeName: row.BookTypeName,
            ItemName: row.ItemName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Bookwise-Groupwise" && reportType === "summary") {
        parentKey = "BookTypeName";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = BookWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = BookWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = BookWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = BookWiseGroupWiseSummData?.MainGrpwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            BookTypeName: row.BookTypeName,
            ProductionGroupMstName: row.ProductionGroupMstName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Bookwise-Monthwise" && reportType === "summary") {
        parentKey = "BookTypeName";
        childKey = "Month_Name";

        const financialYearOrder = [
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
          "January",
          "February",
          "March",
        ];

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = BookWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns1.push(
              { key: `${month}_Taka`, label: `${month} Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_Meter`, label: `${month} Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const { BookTypeName, Month_Name, TotInwTaka, TotInwMeter } = item;

            if (!grouped[BookTypeName]) {
              grouped[BookTypeName] = { BookTypeName };

              uniqueMonths.forEach((m) => {
                grouped[BookTypeName][`${m}_Taka`] = "0";
                grouped[BookTypeName][`${m}_Meter`] = "0";
              });
            }

            grouped[BookTypeName][`${Month_Name}_Taka`] =
              formatIndianRupee1(TotInwTaka);
            grouped[BookTypeName][`${Month_Name}_Meter`] =
              formatIndianRupee(TotInwMeter);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows1 = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = BookWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_BalTaka`, label: `${month} Bal Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_BalMeter`, label: `${month} Bal Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const { BookTypeName, Month_Name, TotBalTaka, TotBalMeter } = item;

            if (!grouped[BookTypeName]) {
              grouped[BookTypeName] = { BookTypeName };

              uniqueMonths.forEach((m) => {
                grouped[BookTypeName][`${m}_BalTaka`] = "0";
                grouped[BookTypeName][`${m}_BalMeter`] = "0";
              });
            }

            grouped[BookTypeName][`${Month_Name}_BalTaka`] =
              formatIndianRupee1(TotBalTaka);
            grouped[BookTypeName][`${Month_Name}_BalMeter`] =
              formatIndianRupee(TotBalMeter);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = BookWiseMonthWiseSummData?.MonthWiseSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_OpTaka`, label: `${month} Op Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_OpMeter`, label: `${month} Op Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const { BookTypeName, Month_Name, TotOpwTaka, TotOpwMeter } = item;

            if (!grouped[BookTypeName]) {
              grouped[BookTypeName] = { BookTypeName };

              uniqueMonths.forEach((m) => {
                grouped[BookTypeName][`${m}_OpTaka`] = "0";
                grouped[BookTypeName][`${m}_OpMeter`] = "0";
              });
            }

            grouped[BookTypeName][`${Month_Name}_OpTaka`] =
              formatIndianRupee1(TotOpwTaka);
            grouped[BookTypeName][`${Month_Name}_OpMeter`] =
              formatIndianRupee(TotOpwMeter);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = BookWiseMonthWiseSummData?.MainMonthwiseDlvSum || [];

          const rawMonths = [...new Set(arr.map((i) => i.Month_Name))];
          const uniqueMonths = financialYearOrder.filter((m) =>
            rawMonths.includes(m),
          );

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
          ];

          uniqueMonths.forEach((month) => {
            columns.push(
              { key: `${month}_DlvTp`, label: `${month} Tp`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_DlvTaka`, label: `${month} Delivery Taka`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
              { key: `${month}_DlvMeter`, label: `${month} Delivery Meter`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              {
                key: `${month}_ShortageMeter`,
                label: `${month} Shortage Meter`,
                align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
              },
              { key: `${month}_Amount`, label: `${month} Amount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_Gst`, label: `${month} Gst`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_DiscountAmount`, label: `${month} Discount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_TaxableAmt`, label: `${month} Taxable Amt`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
              { key: `${month}_NetAmount`, label: `${month} Net Amount`, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            );
          });

          const grouped = {};

          arr.forEach((item) => {
            const {
              BookTypeName,
              Month_Name,
              DlvTp,
              DlvTaka,
              DlvMeter,
              DlvFinishShortageMeter_N,
              Amount,
              Gst,
              DiscountAmount,
              TaxableAmt,
              NetAmount,
            } = item;

            if (!grouped[BookTypeName]) {
              grouped[BookTypeName] = { BookTypeName };

              uniqueMonths.forEach((m) => {
                grouped[BookTypeName][`${m}_DlvTp`] = "0";
                grouped[BookTypeName][`${m}_DlvTaka`] = "0";
                grouped[BookTypeName][`${m}_DlvMeter`] = "0";
                grouped[BookTypeName][`${m}_ShortageMeter`] = "0";
                grouped[BookTypeName][`${m}_Amount`] = "0";
                grouped[BookTypeName][`${m}_Gst`] = "0";
                grouped[BookTypeName][`${m}_DiscountAmount`] = "0";
                grouped[BookTypeName][`${m}_TaxableAmt`] = "0";
                grouped[BookTypeName][`${m}_NetAmount`] = "0";
              });
            }

            grouped[BookTypeName][`${Month_Name}_DlvTp`] =
              formatIndianRupee1(DlvTp);
            grouped[BookTypeName][`${Month_Name}_DlvTaka`] =
              formatIndianRupee1(DlvTaka);
            grouped[BookTypeName][`${Month_Name}_DlvMeter`] =
              formatIndianRupee(DlvMeter);
            grouped[BookTypeName][`${Month_Name}_ShortageMeter`] =
              formatIndianRupee(DlvFinishShortageMeter_N);
            grouped[BookTypeName][`${Month_Name}_Amount`] =
              formatIndianRupee1(Amount);
            grouped[BookTypeName][`${Month_Name}_Gst`] =
              formatIndianRupee1(Gst);
            grouped[BookTypeName][`${Month_Name}_DiscountAmount`] =
              formatIndianRupee1(DiscountAmount);
            grouped[BookTypeName][`${Month_Name}_TaxableAmt`] =
              formatIndianRupee1(TaxableAmt);
            grouped[BookTypeName][`${Month_Name}_NetAmount`] =
              formatIndianRupee1(NetAmount);
          });

          const allRows = Object.values(grouped);
          const totalLength = allRows.length.toString().length;

          rows = allRows.map((row, i) => ({
            id: i,
            srNumber: (i + 1).toString().padStart(totalLength, "0"),
            ...row,
          }));
        }
      }

      if (GroupKey === "Monthwise" && reportType === "summary") {
        parentKey = "Month_Name";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = MonthWiseMonthWiseSummData?.MonthWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = MonthWiseMonthWiseSummData?.MonthWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = MonthWiseMonthWiseSummData?.MonthWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = MonthWiseMonthWiseSummData?.MainMonthDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            Month_Name: row.Month_Name,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Monthwise-Partywise" && reportType === "summary") {
        parentKey = "Month_Name";
        childKey = "AcName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = MonthWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = MonthWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = MonthWisePartyWiseSummData?.AcWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = MonthWisePartyWiseSummData?.MainAcwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "AcName", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            Month_Name: row.Month_Name,
            AcName: row.AcName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Monthwise-Itemwise" && reportType === "summary") {
        parentKey = "Month_Name";
        childKey = "ItemName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = MonthWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = MonthWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = MonthWiseItemWiseSummData?.ItemWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = MonthWiseItemWiseSummData?.MainItemwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter",
              align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            Month_Name: row.Month_Name,
            ItemName: row.ItemName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Monthwise-Groupwise" && reportType === "summary") {
        parentKey = "Month_Name";
        childKey = "ProductionGroupMstName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = MonthWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = MonthWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = MonthWiseGroupWiseSummData?.GrpWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = MonthWiseGroupWiseSummData?.MainGrpwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "ProductionGroupMstName", label: "Group Name", width: 130 },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            Month_Name: row.Month_Name,
            ProductionGroupMstName: row.ProductionGroupMstName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      if (GroupKey === "Monthwise-Bookwise" && reportType === "summary") {
        parentKey = "Month_Name";
        childKey = "BookTypeName";

        // ----------- INWARD ----------- //
        if (activeInfoButton === "Inward") {
          const arr = MonthWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns1 = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotInwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotInwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows1 = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotInwMeter: formatIndianRupee1(row.TotInwMeter),
            TotInwTaka: formatIndianRupee1(row.TotInwTaka),
          }));
        }

        // ----------- BALANCE ----------- //
        else if (activeInfoButton === "Balance") {
          const arr = MonthWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", width: 130, align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotBalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotBalMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotBalMeter: formatIndianRupee1(row.TotBalMeter),
            TotBalTaka: formatIndianRupee1(row.TotBalTaka),
          }));
        }

        // ----------- OPENING ----------- //
        else if (activeInfoButton === "Opening") {
          const arr = MonthWiseBookWiseSummData?.BookWiseSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "TotOpwTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "TotOpwMeter", label: "Total Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            ...row,
            TotOpwMeter: formatIndianRupee1(row.TotOpwMeter),
            TotOpwTaka: formatIndianRupee1(row.TotOpwTaka),
          }));
        }

        // ----------- DELIVERY ----------- //
        else if (activeInfoButton === "Delivery") {
          const arr = MonthWiseBookWiseSummData?.MainBookwiseDlvSum || [];
          const totalLength = arr.length.toString().length;

          columns = [
            { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
            { key: "Month_Name", label: "Month Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "BookTypeName", label: "Book Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
            { key: "DlvTp", label: "Tp", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvTaka", label: "Total Delivery Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, rupees: "true" },
            { key: "DlvMeter", label: "Total Delivery Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            {
              key: "DlvFinishShortageMeter_N",
              label: "Shortage Meter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true"
            },
            { key: "Amount", label: "Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "Gst", label: "Gst", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "DiscountAmount", label: "Discount Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "TaxableAmt", label: "Taxable Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
            { key: "NetAmount", label: "Net Amount", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: "true" },
          ];

          rows = arr.map((row, index) => ({
            id: index,
            srNumber: (index + 1).toString().padStart(totalLength, "0"),
            Month_Name: row.Month_Name,
            BookTypeName: row.BookTypeName,
            DlvMeter: formatIndianRupee1(row.DlvMeter),
            DlvTaka: formatIndianRupee1(row.DlvTaka),
            DlvTp: formatIndianRupee1(row.DlvTp),
            Amount: formatIndianRupee1(row.Amount),
            DlvFinishShortageMeter_N: formatIndianRupee1(
              row.DlvFinishShortageMeter_N,
            ),
            Gst: formatIndianRupee1(row.Gst),
            DiscountAmount: formatIndianRupee1(row.DiscountAmount),
            TaxableAmt: formatIndianRupee1(row.TaxableAmt),
            NetAmount: formatIndianRupee1(row.NetAmount),
          }));
        }
      }

      return { columns, rows, parentKey, childKey, columns1, rows1 };
    }, [
      GroupKey,
      reportType,
      activeInfoButton,

      DateWiseDateWiseDtlData,
      DateWisePartyWiseDtlData,
      DateWiseItemWiseDtlData,
      DateWiseGroupWiseDtlData,
      DateWiseBookWiseDtlData,

      PartyWisePartyWiseDtlData,
      PartyWiseDateWiseDtlData,
      PartyWiseItemWiseDtlData,
      PartyWiseGroupWiseDtlData,
      PartyWiseBookWiseDtlData,
      PartyWiseMonthWiseDtlData,

      ItemWiseItemWiseDtlData,
      ItemWiseDateWiseDtlData,
      ItemWisePartyWiseDtlData,
      ItemWiseGroupWiseDtlData,
      ItemWiseBookWiseDtlData,
      ItemWiseMonthWiseDtlData,

      GroupWiseGroupWiseDtlData,
      GroupWiseDateWiseDtlData,
      GroupWisePartyWiseDtlData,
      GroupWiseItemWiseDtlData,
      GroupWiseBookWiseDtlData,
      GroupWiseMonthWiseDtlData,

      BookWiseBookWiseDtlData,
      BookWiseDateWiseDtlData,
      BookWisePartyWiseDtlData,
      BookWiseItemWiseDtlData,
      BookWiseGroupWiseDtlData,
      BookWiseMonthWiseDtlData,

      MonthWiseMonthWiseDtlData,
      MonthWisePartyWiseDtlData,
      MonthWiseItemWiseDtlData,
      MonthWiseGroupWiseDtlData,
      MonthWiseBookWiseDtlData,

      DateWiseDateWiseSummData,
      DateWisePartyWiseSummData,
      DateWiseItemWiseSummData,
      DateWiseGroupWiseSummData,
      DateWiseBookWiseSummData,

      PartyWisePartyWiseSummData,
      PartyWiseDateWiseSummData,
      PartyWiseItemWiseSummData,
      PartyWiseGroupWiseSummData,
      PartyWiseBookWiseSummData,
      PartyWiseMonthWiseSummData,

      ItemWiseItemWiseSummData,
      ItemWiseDateWiseSummData,
      ItemWisePartyWiseSummData,
      ItemWiseGroupWiseSummData,
      ItemWiseBookWiseSummData,
      ItemWiseMonthWiseSummData,

      MonthWiseMonthWiseSummData,
      MonthWisePartyWiseSummData,
      MonthWiseItemWiseSummData,
      MonthWiseGroupWiseSummData,
      MonthWiseBookWiseSummData,

      GroupWiseGroupWiseSummData,
      GroupWiseDateWiseSummData,
      GroupWisePartyWiseSummData,
      GroupWiseItemWiseSummData,
      GroupWiseBookWiseSummData,
      GroupWiseMonthWiseSummData,

      BookWiseBookWiseSummData,
      BookWiseDateWiseSummData,
      BookWisePartyWiseSummData,
      BookWiseItemWiseSummData,
      BookWiseGroupWiseSummData,
      BookWiseMonthWiseSummData,
    ]);


  const isLoading =
    isSubmitted &&
    (() => {
      const isDetail = reportType === "detail";
      const isSummary = reportType === "summary";

      const check = (groupKey, dtlData, summData) =>
        GroupKey === groupKey &&
        ((isDetail && dtlData === null) ||
          (isSummary && summData === null));

      return (
        // ✅ DATEWISE
        check("DateWise", DateWiseDateWiseDtlData, DateWiseDateWiseSummData) ||
        check("DateWise-Partywise", DateWisePartyWiseDtlData, DateWisePartyWiseSummData) ||
        check("DateWise-Itemwise", DateWiseItemWiseDtlData, DateWiseItemWiseSummData) ||
        check("DateWise-Groupwise", DateWiseGroupWiseDtlData, DateWiseGroupWiseSummData) ||
        check("DateWise-Bookwise", DateWiseBookWiseDtlData, DateWiseBookWiseSummData) ||

        // ✅ PARTYWISE
        check("Partywise", PartyWisePartyWiseDtlData, PartyWisePartyWiseSummData) ||
        check("Partywise-DateWise", PartyWiseDateWiseDtlData, PartyWiseDateWiseSummData) ||
        check("Partywise-Itemwise", PartyWiseItemWiseDtlData, PartyWiseItemWiseSummData) ||
        check("Partywise-Groupwise", PartyWiseGroupWiseDtlData, PartyWiseGroupWiseSummData) ||
        check("Partywise-Bookwise", PartyWiseBookWiseDtlData, PartyWiseBookWiseSummData) ||
        check("Partywise-Monthwise", PartyWiseMonthWiseDtlData, PartyWiseMonthWiseSummData) ||

        // ✅ ITEMWISE
        check("Itemwise", ItemWiseItemWiseDtlData, ItemWiseItemWiseSummData) ||
        check("Itemwise-DateWise", ItemWiseDateWiseDtlData, ItemWiseDateWiseSummData) ||
        check("Itemwise-Partywise", ItemWisePartyWiseDtlData, ItemWisePartyWiseSummData) ||
        check("Itemwise-Groupwise", ItemWiseGroupWiseDtlData, ItemWiseGroupWiseSummData) ||
        check("Itemwise-Bookwise", ItemWiseBookWiseDtlData, ItemWiseBookWiseSummData) ||
        check("Itemwise-Monthwise", ItemWiseMonthWiseDtlData, ItemWiseMonthWiseSummData) ||

        // ✅ GROUPWISE
        check("Groupwise", GroupWiseGroupWiseDtlData, GroupWiseGroupWiseSummData) ||
        check("Groupwise-DateWise", GroupWiseDateWiseDtlData, GroupWiseDateWiseSummData) ||
        check("Groupwise-Partywise", GroupWisePartyWiseDtlData, GroupWisePartyWiseSummData) ||
        check("Groupwise-Itemwise", GroupWiseItemWiseDtlData, GroupWiseItemWiseSummData) ||
        check("Groupwise-Bookwise", GroupWiseBookWiseDtlData, GroupWiseBookWiseSummData) ||
        check("Groupwise-Monthwise", GroupWiseMonthWiseDtlData, GroupWiseMonthWiseSummData) ||

        // ✅ BOOKWISE
        check("Bookwise", BookWiseBookWiseDtlData, BookWiseBookWiseSummData) ||
        check("Bookwise-DateWise", BookWiseDateWiseDtlData, BookWiseDateWiseSummData) ||
        check("Bookwise-Partywise", BookWisePartyWiseDtlData, BookWisePartyWiseSummData) ||
        check("Bookwise-Itemwise", BookWiseItemWiseDtlData, BookWiseItemWiseSummData) ||
        check("Bookwise-Groupwise", BookWiseGroupWiseDtlData, BookWiseGroupWiseSummData) ||
        check("Bookwise-Monthwise", BookWiseMonthWiseDtlData, BookWiseMonthWiseSummData) ||

        // ✅ MONTHWISE
        check("Monthwise", MonthWiseMonthWiseDtlData, MonthWiseMonthWiseSummData) ||
        check("Monthwise-Partywise", MonthWisePartyWiseDtlData, MonthWisePartyWiseSummData) ||
        check("Monthwise-Itemwise", MonthWiseItemWiseDtlData, MonthWiseItemWiseSummData) ||
        check("Monthwise-Groupwise", MonthWiseGroupWiseDtlData, MonthWiseGroupWiseSummData) ||
        check("Monthwise-Bookwise", MonthWiseBookWiseDtlData, MonthWiseBookWiseSummData)
      );
    })();


  return (
    <>
      <style>{`
          .hover-scale-btn {
            transition: transform 0.2s ease-in-out;
            transform: scale(1);
          }

          .hover-scale-btn:hover {
            transform: scale(1.02);
          }

          @media (max-width: 767px) {
            .top-header-responsive {
              flex-direction: column;
              align-items: flex-start !important;
            }

            .path-responsive {
              flex-direction: column;
              align-items: stretch !important;
            }

            .path-text-responsive {
              white-space: normal !important;
              word-break: break-word !important;
            }
          }
        `}</style>

      <div className="pageContainer">
        {/* top header */}
        {/* <div
          className=" p-4"
          style={{
            background:
              "linear-gradient(135deg, rgb(64, 145, 108) 0%, rgb(82, 183, 136) 50%, rgb(116, 198, 157) 100%)",
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.1) 0px 8px 10px -6px",
            borderRadius: "12px",
          }}
        >
          <div
            className="top-header-responsive"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <CiFilter
              className="p-2"
              style={{
                background:
                  isdark === "light"
                    ? "linear-gradient(135deg, rgb(27, 67, 50) 0%, rgb(45, 106, 79) 100%)"
                    : "linear-gradient(135deg, rgb(116, 198, 157) 0%, rgb(149, 213, 178) 100%)",
                boxShadow: "rgba(27, 67, 50, 0.4) 0px 8px 24px",
                color: "rgb(255, 255, 255)",
                fontSize: "50px",
                borderRadius: "10px",
                flexShrink: 0,
              }}
            />

            <h2
              style={{
                color: "rgb(255, 255, 255)",
                fontSize: "clamp(24px, 4vw, 32px)",
                textShadow: "rgba(0, 0, 0, 0.2) 0px 2px 8px",
                margin: 0,
                fontWeight: "700",
                wordBreak: "break-word",
              }}
            >
              Grey Inward Report
            </h2>
          </div>

          <p
            style={{
              fontSize: "15px",
              color:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              fontWeight: "500",
              margin: "8px 0 0 64px",
            }}
          >
            Comprehensive multi-dimensional reporting with advanced filtering
          </p>
        </div> */}

        <div
          className="mt-4 p-4"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
            border: `3px solid ${isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1
              }`,
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px",
            borderRadius: "12px",
          }}
        >
          {/* <div
            className="mb-3"
            style={{
              margin: "8px",
              padding: "10px 16px",
              background:
                isdark === "light"
                  ? "linear-gradient(135deg, rgb(216, 243, 220) 0%, rgb(183, 228, 199) 100%)"
                  : "linear-gradient(135deg, rgb(27, 67, 50) 0%, rgb(45, 106, 79) 100%)",
              borderRadius: "12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                minHeight: "40px",
              }}
            >
              <AiOutlineCalendar
                style={{
                  color: "rgb(255, 255, 255)",
                  fontSize: "32px",
                  padding: "6px",
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                  borderRadius: "6px",
                  flexShrink: 0,
                }}
              />

              <h3
                style={{
                  fontSize: "14px",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour3
                      : "rgb(216, 243, 220)",
                  letterSpacing: "0.05rem",
                  fontWeight: "600",
                  margin: 0,
                }}
              >
                FILTER PARAMETERS
              </h3>
            </div>
          </div> */}

          <div
            className="mt-3 mb-3"
            style={{
              border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour3},`,
              borderRadius: "15px",
              // display: "flex",
              padding: "10px 15px",
              boxshadow: "rgba(0, 0, 0, 0.05) 0px 8px 32px",
            }}
          >
            <Row style={{ position: "relative" }}>
              <Col lg={8} md={12} sm={12}>
                <div style={{ flex: "1 1 300px", minWidth: 0 }}>
                  <Dropdown className="w-100" autoClose="outside">
                    <Dropdown.Toggle
                      style={{
                        width: "100%",
                        padding: "10px 16px",
                        borderRadius: "12px",
                        background:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour6,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour6
                            : "rgb(216, 243, 220)",
                        fontSize: "13px",
                        fontWeight: "600",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                      }}
                      className="shadow-sm hover-scale-btn border-0"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          overflow: "hidden",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour6
                                : "rgb(216, 243, 220)",
                            flexShrink: 0,
                          }}
                        >
                          ▤
                        </span>
                        <span
                          style={{
                            opacity: 0.9,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {items.filter((i) => i.checked).length > 0
                            ? items
                              .filter((i) => i.checked)
                              .map((i) => i.label)
                              .join(" ➝ ")
                            : "Choose configuration and order..."}
                        </span>
                      </div>
                      {/* <span style={{ fontSize: '10px', opacity: 0.6, flexShrink: 0 }}>▼</span> */}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{
                        width: "auto",
                        minWidth: "100%",
                        maxWidth: "600px",
                        padding: "20px",
                        borderRadius: "16px",
                        boxShadow: "0 20px 50px rgba(0,0,0,0.3)",
                        // border: isdark === "light" ? "1px solid rgba(0,0,0,0.1)" : `1px solid rgba(82, 183, 136, 0.2)`,
                        marginTop: "12px",
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour6,
                        zIndex: 10000,
                        border: "none",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-4 pb-2">
                        <span
                          style={{
                            fontSize: "15px",
                            fontWeight: "800",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour6
                                : "rgb(216, 243, 220)",
                          }}
                        >
                          Select & Drag Order
                        </span>
                        <div
                          style={{
                            display: "flex",
                            gap: "12px",
                            alignItems: "center",
                          }}
                        >
                          <button
                            onClick={() => clearAll()}
                            style={{
                              cursor: "pointer",
                              fontSize: "11px",
                              fontWeight: "800",
                              color: "#ffffff",
                              padding: "6px 14px",
                              background: "#e63946",
                              borderRadius: "8px",
                              border: "none",
                              whiteSpace: "nowrap",
                            }}
                          >
                            CLEAR
                          </button>
                        </div>
                      </div>

                      <DndContext
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                        modifiers={[restrictToParentElement]}
                      >
                        <SortableContext
                          items={items.map((i) => i.id)}
                          strategy={verticalListSortingStrategy}
                        >
                          {items.map((item) => (
                            <SortableItem
                              key={item.id}
                              item={item}
                              toggleCheck={toggleCheck}
                              items={items}
                              isdark={isdark}
                              iscolour={iscolour}
                              iscolourDark={iscolourDark}
                            />
                          ))}
                        </SortableContext>
                      </DndContext>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Col>

              <Col lg={4} md={12} sm={12}>
                <div
                  style={{
                    display: "flex",
                    background:
                      isdark === "light"
                        ? "rgba(0, 0, 0, 0.04)"
                        : "rgba(255, 255, 255, 0.05)",
                    borderRadius: "14px",
                    padding: "4px",
                    position: "relative",
                    boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                    width: "100%",
                  }}
                >
                  {/* Sliding Background */}
                  <div
                    style={{
                      position: "absolute",
                      width: "50%", // ✅ FIXED SIMPLE (no calc)
                      height: "calc(100% - 8px)",
                      left: reportType === "detail" ? "0%" : "50%", // ✅ clean movement
                      top: "4px",
                      background:
                        "linear-gradient(135deg, rgb(64, 145, 108) 0%, rgb(45, 106, 79) 100%)",
                      borderRadius: "10px",
                      transition: "all 0.3s ease",
                      zIndex: 1,
                    }}
                  />

                  {["detail", "summary"].map((type) => (
                    <button
                      key={type}
                      onClick={() => {
                        setReportType(type);
                        resetSectionState();
                      }}
                      style={{
                        flex: 1,
                        padding: "10px",
                        border: "none",
                        background: "transparent",
                        color:
                          reportType === type
                            ? "#ffffff"
                            : isdark === "light"
                              ? "rgb(45, 106, 79)"
                              : "rgba(216, 243, 220, 0.6)",
                        fontSize: "14px",
                        fontWeight: "700",
                        cursor: "pointer",
                        zIndex: 2,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {type === "detail" ? "Detail" : "Summary"}
                    </button>
                  ))}
                </div>
              </Col>
            </Row>
          </div>

          <div style={{ margin: "8px" }}>
            <Row className="g-3 align-items-end">
              <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                <div>
                  <h3
                    style={{
                      color:
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour2,
                      fontWeight: "700",
                      fontSize: "13px",
                      marginBottom: "5px",
                    }}
                  >
                    Date Range
                  </h3>
                </div>
                <div>
                  <div
                    onClick={() => setShowDatePicker(true)}
                    className="date"
                    style={{
                      // marginTop: "8px",
                      padding: " 12px 20px",
                      borderRadius: "12px",
                      cursor: "pointer",
                      textAlign: "center",
                      border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour3}`,
                      // backgroundColor: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour2
                          : iscolourDark?.Colour2,
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                <DroupdownFilterBox
                  label="Account Name"
                  data={mainFilterData?.account_list?.map((item) => ({
                    label: item.AcName,
                    value: item.AcID,
                  }))}
                  selectedValue={selectedAccount}
                  setSelectedValue={setSelectedAccount}
                  selectedId={selectedAccountId}
                  setSelectedId={setSelectedAccountId}
                  placeholder="Select Account Name(s)"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                <DroupdownFilterBox
                  label="Production Name"
                  data={mainFilterData?.production_Group_Master_List?.map(
                    (item) => ({
                      label: item.ProductionGroupMstName,
                      value: item.ProductionGroupMstID,
                    }),
                  )}
                  selectedValue={selectedProduction}
                  setSelectedValue={setSelectedProduction}
                  selectedId={selectedProductionId}
                  setSelectedId={setSelectedProductionId}
                  placeholder="Select production group(s)"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                <DroupdownFilterBox
                  label="Quality Name"
                  data={QualityListdata?.Quality?.map((item) => ({
                    label: item.ItemName,
                    value: item.ItemID,
                  }))}
                  selectedValue={selectedQuality}
                  setSelectedValue={setSelectedQuality}
                  selectedId={selectedQualityId}
                  setSelectedId={setSelectedQualityId}
                  placeholder="Select Quality Name(s)"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              <Col xs={12} sm={12} md={6} lg={4} xl={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  <button
                    className="hover-scale-btn"
                    onClick={handleApiCall} // 🔥 ADD THIS
                    style={{
                      ...commonButtonStyle,
                      background:
                        isdark === "light"
                          ? "linear-gradient(135deg, rgb(64, 145, 108) 0%, rgb(45, 106, 79) 100%)"
                          : "linear-gradient(135deg, rgb(82, 183, 136) 0%, rgb(64, 145, 108) 100%)",
                      color: "rgb(255, 255, 255)",
                      border: "none",
                      cursor: "pointer",
                      boxShadow:
                        isdark === "light"
                          ? "rgba(64, 145, 108, 0.4) 0px 4px 16px"
                          : "rgba(82, 183, 136, 0.4) 0px 4px 16px",
                      letterSpacing: "0.05em",
                      fontWidth: "700",
                      padding: "12px"
                    }}
                  >
                    Apply Filter
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {isSubmitted && selected ? (
          isLoading ? (
            <div className="text-center p-4">
              <Loader />
            </div>
          ) : (
            <>
              <div className=" mt-4 mb-4 ">
                <Row className="g-3">
                  {infoButtons.map((button) => {
                    const isSelected = activeInfoButton === button;
                    const isHovered = hoveredButton === button;

                    return (
                      <Col
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3}
                        xl={3}
                        xxl={3}
                        key={button}
                      >
                        <button
                          type="button"
                          className="hover-scale-btn"
                          onClick={() => setActiveInfoButton(button)}
                          // onMouseEnter={() => setHoveredButton(button)}
                          // onMouseLeave={() => setHoveredButton("")}
                          style={{
                            ...commonButtonStyle,
                            backgroundColor: isSelected
                              ? "rgb(64, 145, 108)"
                              : isHovered
                                ? "rgb(116, 198, 157)"
                                : "transparent",
                            border: `2px solid ${isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12}`,

                            color: isSelected
                              ? isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour2
                              : isdark === "light"
                                ? iscolour?.Colour9
                                : iscolourDark?.Colour2,

                            boxShadow: isSelected
                              ? "rgba(64, 145, 108, 0.25) 0px 4px 12px"
                              : isHovered
                                ? "rgba(116, 198, 157, 0.25) 0px 4px 12px"
                                : "none",
                          }}
                        >
                          {button}
                        </button>
                      </Col>
                    );
                  })}
                </Row>
              </div>

              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8,
                    padding: "14px",
                  }}
                >
                  <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight: "700" }}>
                    {GroupKey?.toUpperCase()} DATA
                  </h2>
                </div>

                <div>
                  {
                    parentKey ? (
                      childKey ? (
                        <GreyParentChild
                          columns={columns}
                          data={rows}
                          parentKey={parentKey}
                          childKey={childKey}
                        />
                      ) : (
                        <GreyParentChild
                          columns={columns}
                          data={rows}
                          parentKey={parentKey}
                        />
                      )
                    ) : (
                      <GreyTable
                        columns={columns1}
                        data={rows1}
                        iscolourDark={iscolourDark}
                        iscolour={iscolour}
                      />
                    )
                  }
                </div>
              </div>
            </>
          )
        ) : (
          <>
            <div className="text-center pt-5" style={{ color: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 }}>
              <h3>Select & Drag Order</h3>
            </div>
          </>
        )}
      </div>

      {showDatePicker && (
        <>
          <CommonCalendarStyle
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />

          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
            onClick={() => setShowDatePicker(false)}
          >

            <div
              style={{
                background:
                  isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour7,

                borderRadius: "20px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Calendar
                className="custom-calendar"
                selectRange={true}
                onChange={(value) => {
                  if (Array.isArray(value)) {
                    setDateRange([
                      {
                        startDate: value[0],
                        endDate: value[1],
                        key: "selection",
                      },
                    ]);
                  }
                }}
                value={
                  dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? [dateRange[0].startDate, dateRange[0].endDate]
                    : null
                }
              />

              <div
                className="date-picker-footer"
                style={{
                  textAlign: "center",
                  marginTop: "15px",
                  padding: "12px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour7,
                  borderRadius: "0 0 20px 20px",
                }}
              >
                <button
                  onClick={() => setShowDatePicker(false)}
                  style={{
                    padding: "10px",
                    borderRadius: "12px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "700",
                    color: "#fff",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour3,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                    transition: "0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = "0.85";
                    e.target.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = "1";
                    e.target.style.transform = "scale(1)";
                  }}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
